/* Interlinked — Bundle builder */
(function () {
  'use strict';

  /* money(), fmt(), esc() en rootUrl() komen uit assets/il-utils.js, dat de
     sectie vóór dit bestand laadt. Hier stonden eigen kopieën van de eerste
     drie, en rootUrl stond drie keer uitgeschreven. */
  var U = window.ILUtils;
  var money = U.money;
  var fmt = U.fmt;
  var esc = U.esc;
  var rootUrl = U.rootUrl;

  function init(root) {
    // boot() (DOMContentLoaded) en de shopify:section:load-listener kunnen
    // allebei op dezelfde root terechtkomen (bijv. bij Horizons soft-navigatie
    // tussen pagina's). Zonder deze guard bouwt elke aanroep zijn eigen closure
    // met eigen listeners op dezelfde knoppen, en voert één klik alles dubbel uit.
    if (root.__ilbbInit) return;
    root.__ilbbInit = true;
    var dataEl = root.querySelector('[data-ilbb-data]');
    if (!dataEl) return;
    var data;
    try { data = JSON.parse(dataEl.textContent); } catch (e) { return; }
    var S = data.settings;
    var FALLBACK_COUNTS = { B: 3, F: 5, C: 10 };
    /* Oude optiewaarden (S/M/L) mappen op de nieuwe maatletters (B/F/C). */
    var LETTER_ALIAS = { S: 'B', M: 'F', L: 'C' };
    /* Zoveel charmfoto's passen naast elkaar in de rij vóór de koopknop: op
       390px is dat een raster van vijf kolommen van 66px. De rij houdt dat
       raster ook bij drie charms aan, zodat een charm even groot blijft welk
       aantal je ook kiest; boven de vijf wordt het een scroller. */
    /* Omkering van FALLBACK_COUNTS: 3 -> B, 5 -> F, 10 -> C. Zie sizeLetter. */
    var COUNT_LETTER = {};
    Object.keys(FALLBACK_COUNTS).forEach(function (l) { COUNT_LETTER[FALLBACK_COUNTS[l]] = l; });

    /* Charm-categorieën uit theme editor-blokken: label + lijst met charm-handles */
    var CATS = [];
    (data.categories || []).forEach(function (c) {
      if (!c || !c.label) return;
      var handles = [];
      (c.handles || []).forEach(function (h) {
        h = String(h || '').trim().toLowerCase();
        if (h) handles.push(h);
      });
      if (handles.length) CATS.push({ label: c.label, handles: handles });
    });

    var state = {
      tab: 'curated',
      vibe: null,
      size: null,
      metal: S.defaultMetal,
      /* picks is een lijst van charmnamen in de volgorde waarin je ze aantikt.
         Eén charm zit er één keer in: nog een tik haalt hem er weer af. */
      custom: { metal: S.defaultMetal, size: null, picks: [], category: 'all', step: 1 }
    };

    var STEP_COUNT = 3;

    var els = {
      tabs: root.querySelectorAll('[data-ilbb-tab]'),
      panels: root.querySelectorAll('[data-ilbb-panel]'),
      vibes: root.querySelectorAll('[data-ilbb-vibe]'),
      builder: root.querySelector('[data-ilbb-builder]'),
      hero: root.querySelector('.ilbb__hero'),
      heroMedia: root.querySelector('[data-ilbb-hero-media]'),
      heroDots: root.querySelector('[data-ilbb-hero-dots]'),
      heroPrev: root.querySelector('[data-ilbb-hero-prev]'),
      heroNext: root.querySelector('[data-ilbb-hero-next]'),
      quote: root.querySelector('[data-ilbb-quote]'),
      metals: root.querySelector('[data-ilbb-metals]'),
      sizes: root.querySelector('[data-ilbb-sizes]'),
      sizeInfo: root.querySelector('[data-ilbb-sizeinfo]'),
      charmsOpen: root.querySelector('[data-ilbb-charms-open]'),
      zoom: root.querySelector('[data-ilbb-zoom]'),
      zoomBaan: root.querySelector('[data-ilbb-zoom-baan]'),
      zoomClose: root.querySelector('[data-ilbb-zoom-close]'),
      doosOpen: root.querySelector('[data-ilbb-doos-open]'),
      sheet: root.querySelector('[data-ilbb-sheet]'),
      sheetTitle: root.querySelector('[data-ilbb-sheet-title]'),
      sheetSub: root.querySelector('[data-ilbb-sheet-sub]'),
      sheetGrid: root.querySelector('[data-ilbb-sheet-grid]'),
      sheetClose: root.querySelector('[data-ilbb-sheet-close]'),
      nudge: root.querySelector('[data-ilbb-nudge]'),
      atc: root.querySelector('[data-ilbb-atc]'),
      customMetals: root.querySelector('[data-ilbb-custom-metals]'),
      customMetalLabel: root.querySelector('[data-ilbb-custom-metal-label]'),
      customSizes: root.querySelector('[data-ilbb-custom-sizes]'),
      charmCats: root.querySelector('[data-ilbb-charm-cats]'),
      charmGrid: root.querySelector('[data-ilbb-charm-grid]'),
      picked: root.querySelector('[data-ilbb-picked]'),
      railStep: root.querySelector('[data-ilbb-rail-step]'),
      railName: root.querySelector('[data-ilbb-rail-name]'),
      railBar: root.querySelector('[data-ilbb-rail-bar]'),
      wzItems: root.querySelectorAll('[data-ilbb-wz]'),
      finalBand: root.querySelector('[data-ilbb-final-band]'),
      panelCustom: root.querySelector('[data-ilbb-panel="custom"]'),
      gal: root.querySelector('[data-ilbb-gal]'),
      galArm: root.querySelector('[data-ilbb-gal-arm]'),
      galStip: root.querySelector('[data-ilbb-gal-stip]'),
      afTerug: root.querySelector('[data-ilbb-af-terug]'),
      customNudge: root.querySelector('[data-ilbb-custom-nudge]'),
      customAtc: root.querySelector('[data-ilbb-custom-atc]'),
      sticky: root.querySelector('[data-ilbb-sticky]'),
      stickyTitle: root.querySelector('[data-ilbb-sticky-title]'),
      stickyPrice: root.querySelector('[data-ilbb-sticky-price]'),
      stickyNote: root.querySelector('[data-ilbb-sticky-note]'),
      stickyAtc: root.querySelector('[data-ilbb-sticky-atc]'),
      success: root.querySelector('[data-ilbb-success]'),
      successTitle: root.querySelector('[data-ilbb-success-title]'),
      successStapel: root.querySelector('[data-ilbb-success-stapel]'),
      successNaam: root.querySelector('[data-ilbb-success-naam]'),
      successPrijs: root.querySelector('[data-ilbb-success-prijs]'),
      successClose: root.querySelector('[data-ilbb-success-close]'),
      suggest: root.querySelector('[data-ilbb-suggest]'),
      continueBtn: root.querySelector('[data-ilbb-continue]'),
      toCart: root.querySelector('[data-ilbb-to-cart]')
    };

    /* De samenvattingskaart staat twee keer in de pagina, één keer per tab.
       De prefix houdt de twee sets elementen uit elkaar. */
    function sumEls(p) {
      return {
        title: root.querySelector('[data-ilbb-' + p + 'sum-title]'),
        contents: root.querySelector('[data-ilbb-' + p + 'sum-contents]'),
        price: root.querySelector('[data-ilbb-' + p + 'sum-price]'),
        opbouw: root.querySelector('[data-ilbb-' + p + 'sum-opbouw]')
      };
    }
    els.sum = sumEls('');
    els.customSum = sumEls('custom-');

    /* De eerste regel van "In je doosje", op elke tab een eigen exemplaar. */
    function doosEls(p) {
      return {
        foto: root.querySelector('[data-ilbb-' + p + 'doos-charm]'),
        titel: root.querySelector('[data-ilbb-' + p + 'doos-charms-t]'),
        namen: root.querySelector('[data-ilbb-' + p + 'doos-charms-s]')
      };
    }
    els.doos = doosEls('');
    els.customDoos = doosEls('custom-');

    /* Bewaren en delen. Alleen de tab Zelf samenstellen heeft deze, want daar
       bouw je iets dat van jou is; een gecureerde set is met één link al te
       delen via zijn eigen adres. */
    els.deel = root.querySelector('[data-ilbb-deel]');
    els.deelTekst = root.querySelector('[data-ilbb-deel-tekst]');
    els.terug = root.querySelector('[data-ilbb-terug]');
    els.terugWis = root.querySelector('[data-ilbb-terug-wis]');

    /* ---------- helpers ---------- */

    /* De maatletter komt uit het aantal charms in de optiewaarde, niet uit het eerste
       teken. Anders hangt de bouwer aan de variantnaam: "Basic (3 charms)" geeft B, maar
       zodra dezelfde variant "3 charms" heet wordt de letter "3", matcht er geen variant
       en ligt de pagina plat. Staat er geen aantal in de waarde, dan geldt het oude
       gedrag, met LETTER_ALIAS als terugval voor oude S/M/L-data. */
    function sizeLetter(opt1) {
      var n = leadingCount(opt1);
      if (n != null && COUNT_LETTER[n]) return COUNT_LETTER[n];
      var raw = (opt1 || '').trim().charAt(0).toUpperCase();
      return LETTER_ALIAS[raw] || raw;
    }

    function sizeName(letter) {
      return (S.sizeNames && S.sizeNames[letter]) || letter;
    }

    function isDigit(c) { return c >= '0' && c <= '9'; }

    /* Eerste cijferreeks in de optiewaarde, of null als er geen cijfer in staat.
       "Basic (3 charms)" en "3 charms" geven allebei 3. */
    function leadingCount(opt1) {
      var s = opt1 || '';
      var digits = '';
      for (var i = 0; i < s.length; i++) {
        var c = s.charAt(i);
        if (isDigit(c)) digits += c;
        else if (digits) break;
      }
      return digits ? parseInt(digits, 10) : null;
    }

    function charmCount(opt1, letter) {
      var n = leadingCount(opt1);
      return n != null ? n : (FALLBACK_COUNTS[letter] || 3);
    }

    /* Wat de onderdelen van deze set los zouden kosten.

       Dit was v.compareAt, en die prijs is precies armband plus charms: 26,80,
       36,70 en 61,45. De charm tool zat er niet in, terwijl die sinds 6 augustus
       2026 gratis in elke set-doos gaat. Los ben je hem wél kwijt, dus hoort hij
       in de vergelijking; besloten 8 augustus 2026.

       Vandaar een eigen som uit drie instellingen in plaats van compareAt.
       Ontbreekt er een, dan blijft compareAt de terugval en verandert er niets:
       een leeg veld in de editor mag de prijsregel niet leeg maken. */
    function looseTotal(variant, count) {
      if (S.partBand && S.partCharm && count > 0) {
        return S.partBand + (S.partCharm * count) + (S.partTool || 0);
      }
      return variant && variant.compareAt ? variant.compareAt : 0;
    }

    function metalsOf(variants) {
      var metals = [];
      variants.forEach(function (v) { if (v.opt2 && metals.indexOf(v.opt2) === -1) metals.push(v.opt2); });
      return metals;
    }

    /* Vertalingen kunnen optiewaarden herschrijven ("Zilver" -> "Silver");
       val daarom terug op de eerste bestaande waarde in plaats van niets te matchen. */
    function effMetal(variants, wanted) {
      var metals = metalsOf(variants);
      if (!metals.length) return null;
      if (wanted && metals.indexOf(wanted) !== -1) return wanted;
      return metals[0];
    }

    function variantFor(variants, size, metal) {
      for (var i = 0; i < variants.length; i++) {
        var v = variants[i];
        if (sizeLetter(v.opt1) !== size) continue;
        if (v.opt2 && metal && v.opt2 !== metal) continue;
        return v;
      }
      return null;
    }

    function sizesOf(variants, metal) {
      var seen = {}, out = [];
      variants.forEach(function (v) {
        if (v.opt2 && metal && v.opt2 !== metal) return;
        var l = sizeLetter(v.opt1);
        if (!seen[l]) { seen[l] = true; out.push({ letter: l, variant: v }); }
      });
      var order = { B: 0, F: 1, C: 2 };
      out.sort(function (a, b) {
        var oa = order[a.letter] != null ? order[a.letter] : 9;
        var ob = order[b.letter] != null ? order[b.letter] : 9;
        return oa - ob;
      });
      return out;
    }

    /* Houd de gekozen maat vast zolang hij leverbaar is; anders de eerste leverbare maat. */
    function pickSize(current, entries) {
      var chosen = null;
      entries.forEach(function (e) { if (e.letter === current) chosen = e; });
      if (chosen && chosen.variant.available) return current;
      var firstAvail = null;
      entries.forEach(function (e) { if (!firstAvail && e.variant.available) firstAvail = e; });
      if (firstAvail) return firstAvail.letter;
      if (chosen) return current;
      return entries.length ? entries[0].letter : null;
    }

    function publish(name, payload) {
      if (!S.analytics) return;
      try {
        if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') {
          window.Shopify.analytics.publish(name, payload || {});
        }
      } catch (e) { /* noop */ }
    }

    /* ---------- size cards (shared) ---------- */

    /* Drie tegels naast elkaar. De sticker ligt over de rand van de tegel en
       neemt dus geen hoogte in: alle drie blijven even hoog, ook als de tekst
       op de sticker over twee regels gaat. */
    function buildSizeCard(entry, selected, vibeColor) {
      var v = entry.variant;
      var count = charmCount(v.opt1, entry.letter);
      var card = document.createElement(v.available ? 'button' : 'div');
      if (v.available) {
        card.type = 'button';
        card.setAttribute('aria-pressed', selected ? 'true' : 'false');
      }
      card.className = 'ilbb__size' + (selected ? ' is-selected' : '') + (!v.available ? ' is-soldout' : '');
      card.setAttribute('data-size', entry.letter);
      if (vibeColor) card.style.setProperty('--vibe-color', vibeColor);

      /* De aanrader is een ronde sticker op de hoek van de tegel, en uitverkocht
         een regel onder de prijs. Eerst stonden allebei in een strook boven het
         getal, en die strook stond er ook leeg, op de tegels zonder badge, zodat
         alle drie even hoog bleven. Dat las als iets dat niet geladen was. */
      var badge = S.badges ? S.badges[entry.letter] : null;
      var stickerHtml = v.available && badge ? '<span class="ilbb__sticker">' + esc(badge) + '</span>' : '';
      var outHtml = !v.available ? '<span class="ilbb__size-out">' + esc(S.soldOutText) + '</span>' : '';

      /* Hier stond een prijs per charm, en die kon niet kloppen. Een set is een
         armband van €11,95 plus de charms van €4,95 per stuk, met de charm tool
         er gratis bij. De setprijs delen door het aantal charms rekent de
         armband dus mee als charm, en gaf €6,65, €5,59 en €4,50. Trek je de
         armband er wel af, dan kantelt de uitkomst: €2,67 bij drie charms tegen
         €3,30 bij tien. Per charm is de kleinste set de goedkoopste, en dan
         bewijst het getal het tegenovergestelde van "Beste deal".

         Wat wél klopt is de vergelijking met los kopen: armband plus charms plus
         de charm tool, samen 31,75, 41,65 en 66,40. De besparing is dan 11,80,
         13,70 en 21,45 en loopt dus op naar de grootste set.

         Die besparing staat hier op de tegel en niet alleen in de prijsregel,
         want hier wordt vergeleken. En het is de besparing en niet de losse
         prijs, want "los €41,65" naast "€27,95" vraagt een aftrekking op een
         tegel van 114px breed. De losse prijs staat als onderbouwing één keer in
         de regel onder de prijs, waar ook staat waar hij uit bestaat. */
      var saveHtml = '';
      var loose = looseTotal(v, count);
      if (S.savingsText && loose > v.price) {
        saveHtml = '<span class="ilbb__size-save">' +
          esc(fmt(S.savingsText, { amount: money(loose - v.price) })) +
          '</span>';
      }

      /* Rondjes die tellen: één per charm, zwart op de gekozen tegel. Het getal
         blijft ernaast staan, want tien rondjes tel je niet in één oogopslag. */
      var stippen = '';
      for (var d = 0; d < count; d++) stippen += '<i></i>';
      var countText = count + (S.charmsUnit ? ' ' + S.charmsUnit : '');

      card.innerHTML =
        '<span class="ilbb__stippen" aria-hidden="true">' + stippen + '</span>' +
        '<span class="ilbb__size-count">' + esc(countText) + '</span>' +
        '<span class="ilbb__size-price">' + money(v.price) + '</span>' +
        saveHtml + outHtml + stickerHtml;
      return card;
    }

    /* Alleen de status van de gekozen maat, als losse labels. Als beschrijvende
       zin las dit als een run-on: wat je koopt staat al in de foto en in het
       pakketje, dus hier hoort alleen wat er nú van toepassing is. Niets van
       toepassing betekent geen regel, geen lege ruimte. */
    function renderSizeInfo(entry) {
      var el = els.sizeInfo;
      if (!el) return;
      el.innerHTML = '';
      if (!entry) { el.hidden = true; return; }
      var v = entry.variant;
      var html = '';
      var paneel = '';

      if (!v.available) {
        html += '<span class="ilbb__flag ilbb__flag--out">' + esc(S.soldOutText) + '</span>';
        /* Het veld klapt hieronder uit en de aanmelding gaat als klant naar
           Shopify (zie wireNotify). Vroeger was dit een mailto, en die is de
           reden dat er een veld is: op een telefoon opent hij de mailapp met
           een lege mail en maakt vrijwel niemand hem af, terwijl dit de
           bezoeker met de meeste koopintentie van de week kan zijn. */
        if (S.notify) {
          paneel = notifyPaneel(entry);
        }
      } else {
        /* Geen gratis-verzendingsvlag meer. Die stond op de vierde plek waar
           hetzelfde te lezen was: de badge op de grootste tegel, de nudge boven
           de knop en de accordeon zeggen het ook. De nudge blijft, want die
           gaat over jouw winkelwagen en niet over de belofte in het algemeen. */
        if (S.lowStock != null && v.qty != null && v.qty > 0 && v.qty <= S.lowStock) {
          html += '<span class="ilbb__flag ilbb__flag--low">' + esc(fmt(S.lowStockText, { count: v.qty })) + '</span>';
        }
      }

      /* De polsmaat als laatste label, en als enige dat altijd blijft staan.
         Twee persona's gingen bij "Hoeveel charms wil je?" zoeken waar ze hun
         polsomtrek moesten invullen; dit is het antwoord op de plek waar de
         vraag opkomt. Hij staat achter de wisselende meldingen, want die gaan
         over nú en dit label over altijd. */
      if (S.sizeNote) {
        html += '<span class="ilbb__flag ilbb__flag--size">' + esc(S.sizeNote) + '</span>';
      }

      el.innerHTML = (html ? '<div class="ilbb__sizeinfo-flags">' + html + '</div>' : '') + paneel;
      el.hidden = html === '' && paneel === '';
      if (paneel) wireNotify(el, entry);
    }

    /* --- Hou me op de hoogte -------------------------------------------------

       Eén paneel per uitverkochte maat, ingeklapt tot een knop. Het staat onder
       de labels en niet erover: de maten die wél kunnen moeten in beeld blijven,
       en op 390px neemt een paneel over de kaart het hele scherm.

       Ontwerpronde 29 augustus 2026. De trigger was een onderstreepte regel op
       --t-micro in --il-ink-muted: dezelfde vorm die elders op de winkel
       "algemene voorwaarden" is, met een oranje pil ernaast die veel harder
       roept. Dat is de kleinste tekst op het scherm voor de bezoeker met de
       meeste koopintentie van de week. Het is nu een knop met een rand en een
       raakvlak van 44 hoog.

       Uitgeklapt is het één vlak in plaats van drie losse regels. De melding,
       de reden en het veld zaten los onder elkaar zonder dat iets ze bond, en
       het formulier hing zonder omhulsel onder de tegels. Zolang het paneel
       open staat verdwijnt de pil "Even op" uit de labelrij: de kop van het
       paneel zegt het al, en de tegel zelf draagt de oranje strook nog.

       De hulptekst, de foutmelding en de bevestiging deelden één regel, die
       beurtelings van kleur en hoogte wisselde. Dat zijn nu drie dingen: de
       vaste kleine letter, een statusregel die alleen bij een fout verschijnt,
       en een bevestiging die het formulier vervangt.

       Er wordt niets bewaard tussen twee renders. Dat is met opzet: een andere
       maat is een andere variant en dus een andere aanmelding, dus het veld
       hoort dan leeg te zijn. */
    function notifyPaneel(entry) {
      var n = S.notify;
      var id = 'ilbb-notify-' + entry.variant.id;
      var maat = sizeName(entry.letter);
      var label = n.label || 'Hou me op de hoogte';
      var kop = fmt(n.kop, { size: maat });
      var reden = fmt(n.text, { size: maat });
      var okSub = fmt(n.okSub, { size: maat });
      return '' +
        '<div class="ilbb__notify" data-ilbb-notify data-variant="' + entry.variant.id + '">' +
          '<button type="button" class="ilbb__notify-open" data-ilbb-notify-open>' +
            '<span class="ilbb__notify-icoon" aria-hidden="true">✉</span>' +
            esc(label) +
          '</button>' +
          '<div class="ilbb__notify-paneel" data-ilbb-notify-paneel hidden>' +
            '<form class="ilbb__notify-form" data-ilbb-notify-form novalidate>' +
              ((kop || reden)
                ? '<div class="ilbb__notify-tekst">' +
                    (kop ? '<p class="ilbb__notify-kop">' + esc(kop) + '</p>' : '') +
                    (reden ? '<p class="ilbb__notify-reden">' + esc(reden) + '</p>' : '') +
                  '</div>'
                : '') +
              '<label class="ilbb__notify-label" for="' + id + '">' + esc(label) + '</label>' +
              '<div class="ilbb__notify-pil" data-ilbb-notify-pil>' +
                '<input class="ilbb__notify-input" id="' + id + '" type="email" ' +
                  'name="email" autocomplete="email" inputmode="email" spellcheck="false" required ' +
                  'placeholder="' + esc(n.placeholder || 'Je e-mailadres') + '" data-ilbb-notify-veld>' +
                '<button type="submit" class="ilbb__notify-btn" data-ilbb-notify-verzend>' +
                  esc(n.submit || 'Laat het weten') +
                '</button>' +
              '</div>' +
              (n.fijn ? '<p class="ilbb__notify-fijn">' + esc(n.fijn) + '</p>' : '') +
              '<p class="ilbb__notify-status" data-ilbb-notify-status hidden></p>' +
            '</form>' +
            '<div class="ilbb__notify-klaar" data-ilbb-notify-klaar role="status" aria-live="polite" hidden>' +
              '<p class="ilbb__notify-ok">' +
                '<span class="ilbb__notify-vink" aria-hidden="true">✓</span>' +
                esc(n.ok || 'Gelukt') +
              '</p>' +
              (okSub ? '<p class="ilbb__notify-oksub">' + esc(okSub) + '</p>' : '') +
            '</div>' +
          '</div>' +
        '</div>';
    }

    function wireNotify(root, entry) {
      var wrap = root.querySelector('[data-ilbb-notify]');
      if (!wrap) return;
      var open = wrap.querySelector('[data-ilbb-notify-open]');
      var paneel = wrap.querySelector('[data-ilbb-notify-paneel]');
      var form = wrap.querySelector('[data-ilbb-notify-form]');
      var veld = wrap.querySelector('[data-ilbb-notify-veld]');
      var pil = wrap.querySelector('[data-ilbb-notify-pil]');
      var knop = wrap.querySelector('[data-ilbb-notify-verzend]');
      var status = wrap.querySelector('[data-ilbb-notify-status]');
      var klaar = wrap.querySelector('[data-ilbb-notify-klaar]');
      /* De pil "Even op" in de labelrij erboven. Zolang het paneel open staat
         zegt de kop van het paneel hetzelfde, en de tegel draagt de oranje
         strook nog, dus dan hoort hij daar niet twee keer te staan. */
      var uitPil = root.querySelector('.ilbb__flag--out');

      function fout(tekst) {
        if (veld) veld.setAttribute('aria-invalid', 'true');
        if (pil) pil.setAttribute('data-fout', 'true');
        if (!status) return;
        status.textContent = tekst;
        status.hidden = false;
      }

      function schoon() {
        if (veld) veld.removeAttribute('aria-invalid');
        if (pil) pil.removeAttribute('data-fout');
        if (status) status.hidden = true;
      }

      if (open && paneel) {
        open.addEventListener('click', function () {
          open.hidden = true;
          paneel.hidden = false;
          if (uitPil) uitPil.hidden = true;
          if (veld) veld.focus();
        });
      }

      if (!form) return;

      /* Terug van de aanmelding: Shopify stuurt na een geslaagde verzending
         terug naar deze pagina met customer_posted=true. Welke maat het was
         staat in sessionStorage, want de bouwer begint na de herlading
         opnieuw. Dan staat het paneel meteen open op de bevestiging. */
      var MELDING = 'ilbb-voorraadmelding';
      var gemeld = null;
      try { gemeld = sessionStorage.getItem(MELDING); } catch (e) {}
      if (gemeld === String(entry.variant.id) && /[?&]customer_posted=true/.test(location.search)) {
        try { sessionStorage.removeItem(MELDING); } catch (e) {}
        if (open) open.hidden = true;
        if (paneel) paneel.hidden = false;
        if (uitPil) uitPil.hidden = true;
        form.hidden = true;
        if (klaar) klaar.hidden = false;
        wrap.classList.add('is-klaar');
        publish('interlinked_backinstock_signup', { variant: entry.variant.id, size: entry.letter });
      }

      form.addEventListener('submit', function (event) {
        event.preventDefault();
        if (!veld) return;
        var email = (veld.value || '').trim();
        if (!email || email.indexOf('@') < 1 || email.indexOf('.', email.indexOf('@')) < 0) {
          fout(S.notify.err);
          veld.focus();
          return;
        }
        schoon();
        if (knop) { knop.disabled = true; knop.classList.add('is-loading'); }

        /* Tot 1 oktober 2026 ging dit naar Klaviyo back-in-stock, maar daar
           stond geen flow achter, dus er ging nooit een mail uit. Nu wordt de
           bezoeker een klant in Shopify met de tags voorraadmelding en
           terug-<variant-ID>. Komt de maat terug, dan mail je die tag met
           Shopify Email.

           Gewoon verstuurd, met een herlading, en niet met fetch: een POST naar
           /contact met fetch kreeg op 1 oktober 2026 een 403 met Shopify's
           botcontrole, en die moet de bezoeker zelf kunnen afmaken. Zelfde
           route als de mailband (interlinked-mailband.liquid). */
        var velden = {
          form_type: 'customer',
          utf8: '\u2713',
          'contact[email]': email,
          'contact[tags]': 'voorraadmelding,terug-' + entry.variant.id
        };
        var echt = document.createElement('form');
        echt.method = 'post';
        echt.action = rootUrl() + 'contact';
        echt.hidden = true;
        Object.keys(velden).forEach(function (naam) {
          var i = document.createElement('input');
          i.type = 'hidden';
          i.name = naam;
          i.value = velden[naam];
          echt.appendChild(i);
        });
        try { sessionStorage.setItem(MELDING, String(entry.variant.id)); } catch (e) {}
        document.body.appendChild(echt);
        echt.submit();
      });
    }

    /* Welke charms in deze set zitten, vóór de koopknop. Dezelfde lijst die de
       charmlade toont, dus er wordt niets extra's berekend of opgehaald.

       Geen namen onder de foto's, wel als alt-tekst: een schermlezer leest de
       charms dan gewoon op, terwijl er visueel geen tweede tekstlaag onder een
       vakje van 66px komt. */
    /* De held is de knop naar het groot beeld zolang hij de armband toont
       (sinds 24 oktober 2026; daarvoor opende hij de charmlade). */
    function renderCharmsOpen(list, count) {
      var label = S.setCharmsTitle ? fmt(S.setCharmsTitle, { count: count }) : '';
      if (els.charmsOpen) els.charmsOpen.hidden = !list.length || heroMode !== 'armband';
      /* De charmregel in "In je doosje" opent de lade, ook als de held
         foto's toont: daar staan de namen alleen achter elkaar. */
      if (els.doosOpen) els.doosOpen.setAttribute('aria-label', label || S.doosCharmsTitle || '');
    }

    var heroSlideCount = 0;
    var heroIndex = 0;

    /* De echte foto's van de gekozen maat, in de volgorde waarin je ze swipet,
       na de twee beelden van de digitale armband (Bram, 29 oktober 2026: "ik
       wil eigenljk onze mooie digitale weergeving houden als eerste. en dan de
       echte fotos in de fotoslider").

       Ze komen uit het metaveld custom.fotos van de variant: per maat de
       setfoto, de andere kanten, de ver-shots, de achterkant en de verpakking
       (huisstijl/setfoto-slider.js). Heeft een variant dat metaveld niet, dan
       de foto uit de theme-editor voor die maat of de foto van de variant.
       Daarna de productfoto's die niet aan een variant hangen, want die horen
       bij elke maat. */
    function heldFotos(vibe, letter, variant) {
      var out = [];
      var seen = {};
      var voeg = function (src, alt) {
        if (!src || seen[src]) return;
        seen[src] = true;
        out.push({ src: src, alt: alt || vibe.title });
      };
      if (variant && variant.fotos && variant.fotos.length) {
        variant.fotos.forEach(function (f) { if (f) voeg(f.src, f.alt); });
      } else {
        voeg((vibe.images && vibe.images[letter]) || (variant && variant.image) || (vibe.images && vibe.images.base), vibe.title);
      }
      (vibe.extra || []).forEach(function (item) { if (item) voeg(item.src, item.alt); });
      return out;
    }

    function heroKey(slides) {
      return slides.map(function (s) { return s.src; }).join('|');
    }

    /* 'armband' zodra de armband getekend is. Tot 29 oktober 2026 was er ook
       een fotostand zonder armband; die is er niet meer. */
    var heroMode = null;

    /* De held hangt aan de vibe én de maat. Eerst staan de charms die je bij
       deze maat krijgt er als armband: kies je tien, dan zitten er tien in. Daarom staat er onder de maattegels geen aparte
       rij met je charms meer; die liet dezelfde charms een tweede keer zien.

       Tot 21 oktober 2026 lagen ze hier als scheve fotokaartjes. Sinds die dag
       staat dezelfde set op zijn productpagina als armband (il-armband.liquid),
       en twee beelden van één set lazen als twee producten; Bram koos de
       armband (huisstijl/sets-held-keuzes.js).

       Dezelfde dag koos hij hoe die armband wisselt
       (huisstijl/held-wissel-keuzes.js). Hij is altijd 18 links lang, zoals
       de basisarmband: een charm vervangt een basis link, dus een grotere maat
       maakt hem niet langer. De charms vullen vanuit het midden naar buiten,
       zodat wat er al zat bij een grotere maat op zijn plek blijft. Het eerste
       beeld is die armband ingezoomd op de charms, het tweede de hele armband,
       want daarin is een link op een telefoon maar 20 pixels breed: bij 3
       charms zag je vooral basis links en nauwelijks wat er in de set zit, en
       de armband bovenaan een setpagina is ook ingezoomd (Bram, 21 okt; tot
       die dag stond de hele armband eerst). Bij een wissel valt een
       link eruit en klikt de nieuwe erin, met de klik van Zelf samenstellen;
       bij een grotere maat gelijk met de rondjes in de maattegel (45 ms per
       stuk, .is-telt in de CSS). Een bruggetje hangt zijn tweede uiteinde drie
       plekken verder, ook als daar een charm zit. */
    var HELD_LINKS = 18;
    var HELD_ZOOM = 0;
    /* Zoveel beelden van de armband staan er voor de foto's. */
    var HELD_ARMBAND = 2;
    var HELD_ORDE = [];
    (function () {
      var mid = HELD_LINKS / 2 - 1;
      for (var i = 0; i < HELD_LINKS; i++) HELD_ORDE.push(i % 2 ? mid + (i + 1) / 2 : mid - i / 2);
    })();
    var heroArm = null;

    function bouwArmband() {
      els.heroMedia.className = 'ilbb__hero-media ilbb__hero-media--armband';
      els.heroMedia.innerHTML = '';
      heroArm = { banden: [], plekken: [], sleutels: [], onder: 0, zoom: null, zoomAnim: null };
      for (var s = 0; s < 2; s++) {
        var slide = document.createElement('span');
        slide.className = 'ilbb__hero-slide';
        slide.setAttribute('aria-hidden', 'true');
        var band = document.createElement('span');
        band.className = 'ilbb__hero-band';
        var rij = [];
        for (var i = 0; i < HELD_LINKS; i++) {
          var plek = document.createElement('span');
          plek.className = 'ilbb__hero-plek';
          band.appendChild(plek);
          rij.push(plek);
        }
        slide.appendChild(band);
        els.heroMedia.appendChild(slide);
        heroArm.banden.push(band);
        heroArm.plekken.push(rij);
      }
      for (var k = 0; k < HELD_LINKS; k++) heroArm.sleutels.push(null);
    }

    /* Het zoombeeld: de 18 links vergroot tot de charms met een halve basis
       link aan elke kant het vak vullen, tot de maximale linkmaat. Omhoog met
       de helft van wat er onder hangt, zodat een hanger in het vak blijft.

       Stil staat de band op zijn echte breedte, alleen verschoven. Een wissel
       beweegt alleen met transform, want de breedte animeren tekende elk frame
       alles opnieuw en haperde op een telefoon (Bram, 21 okt). Tijdens de
       wissel staat de band op de grootste van de twee maten en schaalt hij
       alleen omlaag: een laag die de browser oprekt is onscherp tot hij
       stilstaat, met scale() op de kleine armband was het beeld bij elke
       wissel even wazig (ook 21 okt). Hangers en uitsneden staan in procenten
       van hun plek en groeien vanzelf mee. */
    function heldZoom(inBeeld, onder) {
      var w = els.heroMedia.clientWidth;
      var vol = [];
      inBeeld.forEach(function (k, i) { if (k) vol.push(i); });
      if (!w || !vol.length) return { w: 0, x: 0, y: 0 };
      var w0 = w / HELD_LINKS;
      var min = vol[0];
      var max = vol[vol.length - 1];
      var celMax = window.matchMedia && window.matchMedia('(min-width: 750px)').matches ? 150 : 92;
      var s = Math.min(w / ((max - min + 2) * w0), celMax / w0);
      var midden = (min + max + 1) / 2 * w0;
      return { w: s * w, x: w / 2 - s * midden, y: -onder * s * w0 / 2 };
    }

    function zoomTransform(z, schaal) {
      return 'translate(' + z.x.toFixed(1) + 'px, ' + z.y.toFixed(1) + 'px)' + (schaal ? ' scale(' + schaal.toFixed(4) + ')' : '');
    }

    function zetZoom(band, z) {
      if (heroArm.zoomAnim) { var a = heroArm.zoomAnim; heroArm.zoomAnim = null; a.cancel(); }
      band.style.width = z.w ? z.w.toFixed(1) + 'px' : '';
      band.style.transform = z.w ? zoomTransform(z) : '';
      heroArm.zoom = z;
    }

    /* Waar de band nu echt staat, ook halverwege een wissel. */
    function zoomNu(band) {
      if (!heroArm.zoomAnim) return heroArm.zoom || { w: 0, x: 0, y: 0 };
      var m = new DOMMatrixReadOnly(getComputedStyle(band).transform);
      return { w: m.a * band.offsetWidth, x: m.e, y: m.f };
    }

    function animeerZoom(band, oud, nieuw) {
      var groot = Math.max(oud.w, nieuw.w);
      zetZoom(band, nieuw);
      band.style.width = groot.toFixed(1) + 'px';
      var anim = band.animate([
        { transform: zoomTransform(oud, oud.w / groot) },
        { transform: zoomTransform(nieuw, nieuw.w / groot) }
      ], { duration: 380, easing: 'cubic-bezier(.4, 0, .2, 1)', fill: 'forwards' });
      heroArm.zoomAnim = anim;
      anim.onfinish = function () {
        if (heroArm && heroArm.zoomAnim === anim) zetZoom(band, nieuw);
      };
    }

    function renderHero(vibe, letter, count, variant) {
      if (!els.heroMedia) return;
      var eerst = heroMode !== 'armband' || !heroArm;
      renderArmband(vibe, count);
      zetFotos(heldFotos(vibe, letter, variant), eerst);
    }

    /* De foto's achter de armband. Wisselt de maat of de set terwijl je naar een
       foto kijkt, dan gaat de baan terug naar de armband, zodat je de wissel
       ziet en niet ineens de foto van een andere maat. Op de hele armband
       blijf je staan. */
    function zetFotos(fotos, eerst) {
      var sleutel = heroKey(fotos);
      if (!eerst && heroArm.fotoSleutel === sleutel) return;
      heroArm.fotoSleutel = sleutel;
      var opFoto = !eerst && heroIndex >= HELD_ARMBAND;
      var oud = els.heroMedia.querySelectorAll('.ilbb__hero-slide--foto');
      for (var i = 0; i < oud.length; i++) oud[i].remove();
      fotos.forEach(function (foto) {
        var slide = document.createElement('span');
        slide.className = 'ilbb__hero-slide ilbb__hero-slide--foto';
        var img = document.createElement('img');
        img.src = foto.src;
        img.srcset = [600, 900, 1200, 1800].map(function (w) { return grootBeeld(foto.src, w) + ' ' + w + 'w'; }).join(', ');
        img.sizes = '(min-width: 900px) 600px, 100vw';
        img.alt = foto.alt;
        img.loading = 'lazy';
        img.decoding = 'async';
        img.draggable = false;
        slide.appendChild(img);
        els.heroMedia.appendChild(slide);
      });
      if (eerst || opFoto) els.heroMedia.scrollLeft = 0;
      syncHeroControls(HELD_ARMBAND + fotos.length, eerst || opFoto ? 0 : heroIndex);
    }

    function renderArmband(vibe, count) {
      var charms = (vibe.charms || []).slice(0, count).filter(function (ch) { return ch && ch.image; });
      var nieuw = [];
      var i;
      for (i = 0; i < HELD_LINKS; i++) nieuw.push(null);
      var onder = 0;
      charms.forEach(function (ch, j) {
        if (j < HELD_LINKS) nieuw[HELD_ORDE[j]] = ch;
        if (ch.handle && S.hangers && S.hangers[ch.handle]) onder = Math.max(onder, hangerOnder(ch.handle));
      });
      var sleutels = nieuw.map(function (ch) { return ch ? ch.image : ''; });
      /* Wat het zoombeeld moet tonen: de charms, en bij een bruggetje ook de
         link waar zijn tweede uiteinde aan hangt. */
      var inBeeld = sleutels.map(function (k) { return !!k; });
      nieuw.forEach(function (ch, p) { if (isBrug(ch) && p + BRUG_AFSTAND < HELD_LINKS) inBeeld[p + BRUG_AFSTAND] = true; });

      /* De eerste keer zonder beweging: dan laadt de pagina alleen. Dezelfde
         armband nog eens doet niets. */
      var eerst = heroMode !== 'armband' || !heroArm;
      heroMode = 'armband';
      if (eerst) bouwArmband();
      var oud = heroArm.sleutels;
      var veranderd = [];
      for (i = 0; i < HELD_LINKS; i++) if (sleutels[i] !== oud[i]) veranderd.push(i);
      if (!veranderd.length) return;

      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var beweeg = !eerst && !reduce && typeof els.heroMedia.animate === 'function';
      var setWissel = veranderd.some(function (p) { return sleutels[p] && oud[p]; });
      var groter = !setWissel && veranderd.some(function (p) { return sleutels[p]; });
      var maxJ = 0;
      veranderd.forEach(function (p) { maxJ = Math.max(maxJ, HELD_ORDE.indexOf(p)); });

      var zoom = heroArm.banden[HELD_ZOOM];
      var zoomOud = zoomNu(zoom);
      var zoomNieuw = heldZoom(inBeeld, onder);
      if (beweeg && zoomOud.w && zoomNieuw.w &&
          (zoomOud.w !== zoomNieuw.w || zoomOud.x !== zoomNieuw.x || zoomOud.y !== zoomNieuw.y)) {
        animeerZoom(zoom, zoomOud, zoomNieuw);
      } else {
        zetZoom(zoom, zoomNieuw);
      }

      heroArm.plekken.forEach(function (rij) {
        veranderd.forEach(function (p, rang) {
          var plek = rij[p];
          var weg = plek.querySelector('.ilbb-link:not(.is-weg)');
          var link = armLink(nieuw[p], 'span');
          link.classList.remove('is-klik');
          plek.appendChild(link);
          if (!weg) return;
          if (!beweeg) { weg.remove(); return; }
          weg.classList.add('is-weg');
          /* Een andere set wisselt van links naar rechts; een grotere maat
             telt mee met de rondjes, een kleinere loopt terug naar het midden. */
          var j = HELD_ORDE.indexOf(p);
          var na = setWissel ? rang * 35 : groter ? j * 45 : (maxJ - j) * 30;
          weg.animate([{ transform: 'none', opacity: 1 }, { transform: 'translateY(45%)', opacity: 0 }],
            { duration: 150, delay: na, easing: 'ease-in', fill: 'forwards' }).onfinish = function () { weg.remove(); };
          link.animate([{ transform: 'translateY(-40%)', opacity: 0 }, { transform: 'none', opacity: 1 }],
            { duration: 240, delay: na + 120, easing: 'cubic-bezier(.2, .7, .3, 1.2)', fill: 'backwards' });
        });
      });
      heroArm.sleutels = sleutels;
      heroArm.charms = nieuw;
      heroArm.inBeeld = inBeeld;
      heroArm.onder = onder;
    }

    /* Het zoombeeld rekent in pixels, dus het rekent opnieuw als het vak van
       maat verandert, en ook als het eerst verborgen was (de tab Zelf
       samenstellen). */
    if (els.heroMedia && window.ResizeObserver) {
      new ResizeObserver(function () {
        if (heroArm) zetZoom(heroArm.banden[HELD_ZOOM], heldZoom(heroArm.inBeeld || [], heroArm.onder));
      }).observe(els.heroMedia);
    }

    /* Groot beeld. Een tik op de held opende de charmlade, terwijl je op een
       telefoon wilt inzoomen (Bram, 24 oktober 2026). Nu opent hij de armband,
       of de foto die in beeld is, over het hele scherm. Hij begint op het hele
       beeld, schermbreed, want knijpen in de browser kan niet verder uitzoomen
       dan waar je begon (Bram, 24 okt: de eerste versie opende al ingezoomd).
       Inzoomen gaat met knijpen, het scrolwiel of een tik op een plek; nog een
       tik zoomt weer uit. Ingezoomd veeg je rond. De lade met de namen blijft
       achter de charmregel in "In je doosje".

       Tijdens een gebaar schaalt het beeld alleen met transform, en als het
       stilstaat krijgt het de echte breedte terug, zodat de foto's scherp zijn
       (dezelfde les als animeerZoom: een opgerekte laag is wazig, de breedte
       per frame aanpassen hapert op een telefoon). */
    function grootBeeld(url, breedte) {
      return url ? String(url).replace(/([?&])width=\d+/, '$1width=' + breedte) : url;
    }

    var ZOOM_RAND = 16;
    var ZOOM_LINK_MAX = 240;
    var ZOOM_LINK_TIK = 110;
    var zoomStand = null;

    /* s is de breedte van het beeld, x en y de linkerbovenhoek in de baan.
       Kleiner dan de baan staat het in het midden, groter blijft de rand in beeld.
       Met vast schrijft hij de breedte echt weg, anders alleen een schaal. */
    function zetZoomStand(s, x, y, vast) {
      var z = zoomStand;
      var W = els.zoomBaan.clientWidth;
      var H = els.zoomBaan.clientHeight;
      s = Math.max(z.fit, Math.min(z.max, s));
      var h = z.hb * s / z.sb;
      x = s <= W ? (W - s) / 2 : Math.min(0, Math.max(W - s, x));
      y = h <= H ? (H - h) / 2 : Math.min(0, Math.max(H - h, y));
      z.s = s; z.x = x; z.y = y;
      if (vast) {
        if (z.n) {
          z.el.style.setProperty('--zl', (s / z.n) + 'px');
          z.el.style.paddingBottom = (s / z.n * z.hang) + 'px';
        } else {
          z.el.style.width = s + 'px';
        }
        z.sb = s;
        z.hb = z.el.offsetHeight || h;
      }
      z.el.style.transform = 'translate(' + x.toFixed(1) + 'px, ' + y.toFixed(1) + 'px)' +
        (z.sb === s ? '' : ' scale(' + (s / z.sb).toFixed(4) + ')');
    }

    /* Naar breedte s, met het punt (px, py) van de baan op zijn plek. */
    function zoomRond(s, px, py, vast) {
      var z = zoomStand;
      var f = Math.max(z.fit, Math.min(z.max, s)) / z.s;
      zetZoomStand(z.s * f, px - (px - z.x) * f, py - (py - z.y) * f, vast);
    }

    /* Een tik zoomt in of uit met een korte beweging, en eindigt scherp. */
    function zoomNaar(s, px, py) {
      var z = zoomStand;
      var van = { s: z.s, x: z.x, y: z.y };
      zoomRond(s, px, py, false);
      var naar = { s: z.s, x: z.x, y: z.y };
      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (reduce) { zetZoomStand(naar.s, naar.x, naar.y, true); return; }
      var t0 = null;
      z.anim = function stap(t) {
        if (zoomStand !== z || z.anim !== stap) return;
        if (t0 === null) t0 = t;
        var p = Math.min(1, (t - t0) / 220);
        var e = 1 - Math.pow(1 - p, 3);
        zetZoomStand(van.s + (naar.s - van.s) * e, van.x + (naar.x - van.x) * e, van.y + (naar.y - van.y) * e, p === 1);
        if (p < 1) requestAnimationFrame(stap);
      };
      requestAnimationFrame(z.anim);
    }

    function openZoom() {
      if (!els.zoom || !els.zoomBaan || typeof els.zoom.showModal !== 'function') return;
      var baan = els.zoomBaan;
      var el;
      var n = 0;
      var hang = 0;
      var verhouding;
      var fotoSlide = heroIndex >= HELD_ARMBAND ? els.heroMedia.querySelectorAll('.ilbb__hero-slide')[heroIndex] : null;
      var foto = fotoSlide ? fotoSlide.querySelector('img') : null;
      if (foto) {
        el = document.createElement('img');
        el.className = 'ilbb__zoom-foto';
        el.src = grootBeeld(foto.currentSrc || foto.src, 2000);
        el.alt = foto.alt || '';
        el.draggable = false;
        verhouding = foto.naturalWidth ? foto.naturalHeight / foto.naturalWidth : 1500 / 2400;
      } else if (heroMode === 'armband' && heroArm && heroArm.charms) {
        el = document.createElement('span');
        el.className = 'ilbb__zoom-band';
        heroArm.charms.forEach(function (ch) {
          var link = armLink(ch && ch.image ? Object.assign({}, ch, { image: grootBeeld(ch.image, 600) }) : ch, 'span');
          link.classList.remove('is-klik');
          el.appendChild(link);
        });
        n = heroArm.charms.length;
        hang = heroArm.onder || 0;
        verhouding = (1 / 1.136 + hang) / n;
      } else {
        return;
      }
      baan.innerHTML = '';
      baan.appendChild(el);
      els.zoom.showModal();
      var W = baan.clientWidth;
      var H = baan.clientHeight;
      var fit = Math.min(W - 2 * ZOOM_RAND, (H - 2 * ZOOM_RAND) / verhouding);
      zoomStand = {
        el: el, n: n, hang: hang, fit: fit,
        max: n ? Math.max(fit, n * ZOOM_LINK_MAX) : fit * 4,
        tik: n ? Math.max(fit * 2, n * ZOOM_LINK_TIK) : fit * 2.5,
        s: fit, sb: fit, hb: fit * verhouding, x: 0, y: 0
      };
      zetZoomStand(fit, 0, 0, true);
      publish('interlinked_hero_zoom', { set: packCtx.title, beeld: foto ? 'foto' : 'armband' });
    }

    if (els.heroMedia && els.zoom && els.zoomBaan) {
      var zoomBaan = els.zoomBaan;
      var wijzers = {};
      var gebaar = null;
      var punt = function (e) {
        var r = zoomBaan.getBoundingClientRect();
        return { x: e.clientX - r.left, y: e.clientY - r.top };
      };
      /* Bij elke vinger erbij of eraf begint het gebaar opnieuw vanaf hier. */
      var beginGebaar = function (bewogen) {
        var ids = Object.keys(wijzers);
        if (!ids.length || !zoomStand) { gebaar = null; return; }
        var a = wijzers[ids[0]];
        var b = ids.length > 1 ? wijzers[ids[1]] : null;
        gebaar = {
          twee: !!b,
          c: b ? { x: (a.x + b.x) / 2, y: (a.y + b.y) / 2 } : { x: a.x, y: a.y },
          d: b ? Math.hypot(a.x - b.x, a.y - b.y) || 1 : 0,
          s: zoomStand.s, x: zoomStand.x, y: zoomStand.y,
          bewogen: !!bewogen,
          ooit2: !!b || !!(gebaar && gebaar.ooit2)
        };
      };

      zoomBaan.addEventListener('pointerdown', function (e) {
        if (!zoomStand || e.button > 0) return;
        if (zoomStand.anim) zoomStand.anim = null;
        try { zoomBaan.setPointerCapture(e.pointerId); } catch (err) {}
        wijzers[e.pointerId] = punt(e);
        beginGebaar(gebaar && gebaar.bewogen);
        if (gebaar) gebaar.op = e.target;
      });
      zoomBaan.addEventListener('pointermove', function (e) {
        if (!gebaar || !wijzers[e.pointerId]) return;
        wijzers[e.pointerId] = punt(e);
        var ids = Object.keys(wijzers);
        var a = wijzers[ids[0]];
        if (gebaar.twee && ids.length > 1) {
          var b = wijzers[ids[1]];
          var c = { x: (a.x + b.x) / 2, y: (a.y + b.y) / 2 };
          var f = Math.max(zoomStand.fit, Math.min(zoomStand.max, gebaar.s * Math.hypot(a.x - b.x, a.y - b.y) / gebaar.d)) / gebaar.s;
          zetZoomStand(gebaar.s * f, c.x - (gebaar.c.x - gebaar.x) * f, c.y - (gebaar.c.y - gebaar.y) * f, false);
          gebaar.bewogen = true;
        } else {
          var dx = a.x - gebaar.c.x;
          var dy = a.y - gebaar.c.y;
          if (!gebaar.bewogen && Math.hypot(dx, dy) < 6) return;
          gebaar.bewogen = true;
          zetZoomStand(zoomStand.s, gebaar.x + dx, gebaar.y + dy, false);
        }
      });
      var loslaten = function (e) {
        if (!wijzers[e.pointerId]) return;
        delete wijzers[e.pointerId];
        var klaar = gebaar;
        if (Object.keys(wijzers).length) { beginGebaar(true); return; }
        gebaar = null;
        if (!zoomStand || !klaar) return;
        if (klaar.bewogen || klaar.ooit2 || e.type === 'pointercancel') {
          zetZoomStand(zoomStand.s, zoomStand.x, zoomStand.y, true);
          return;
        }
        /* Een tik: op het beeld zoomt hij in of uit, ernaast sluit hij. */
        var p = punt(e);
        var opBeeld = klaar.op && (klaar.op === zoomStand.el || zoomStand.el.contains(klaar.op));
        if (zoomStand.s > zoomStand.fit * 1.05) zoomNaar(zoomStand.fit, p.x, p.y);
        else if (opBeeld) zoomNaar(zoomStand.tik, p.x, p.y);
        else els.zoom.close();
      };
      zoomBaan.addEventListener('pointerup', loslaten);
      zoomBaan.addEventListener('pointercancel', loslaten);

      /* Op een computer: het wiel zoomt rond de muis, knijpen op een trackpad ook. */
      var wielKlaar = null;
      zoomBaan.addEventListener('wheel', function (e) {
        if (!zoomStand) return;
        e.preventDefault();
        var p = punt(e);
        zoomRond(zoomStand.s * Math.exp(-e.deltaY * (e.ctrlKey ? 0.01 : 0.0015)), p.x, p.y, false);
        clearTimeout(wielKlaar);
        wielKlaar = setTimeout(function () {
          if (zoomStand) zetZoomStand(zoomStand.s, zoomStand.x, zoomStand.y, true);
        }, 150);
      }, { passive: false });

      /* Met het toetsenbord: plus en min zoomen, de pijlen schuiven. */
      zoomBaan.addEventListener('keydown', function (e) {
        if (!zoomStand) return;
        var W = zoomBaan.clientWidth / 2;
        var H = zoomBaan.clientHeight / 2;
        if (e.key === '+' || e.key === '=') zoomNaar(zoomStand.s * 1.6, W, H);
        else if (e.key === '-') zoomNaar(zoomStand.s / 1.6, W, H);
        else if (e.key === 'ArrowLeft') zetZoomStand(zoomStand.s, zoomStand.x + 60, zoomStand.y, true);
        else if (e.key === 'ArrowRight') zetZoomStand(zoomStand.s, zoomStand.x - 60, zoomStand.y, true);
        else if (e.key === 'ArrowUp') zetZoomStand(zoomStand.s, zoomStand.x, zoomStand.y + 60, true);
        else if (e.key === 'ArrowDown') zetZoomStand(zoomStand.s, zoomStand.x, zoomStand.y - 60, true);
        else return;
        e.preventDefault();
      });

      /* Safari knijpt anders de hele pagina mee. */
      els.zoom.addEventListener('gesturestart', function (e) { e.preventDefault(); });
      els.zoom.addEventListener('close', function () {
        zoomStand = null;
        wijzers = {};
        gebaar = null;
        zoomBaan.innerHTML = '';
      });

      /* De knop ligt over de hele held en zou het vegen naar het tweede beeld
         tegenhouden. Hij laat de aanwijzer daarom door (CSS) en een tik op de
         baan doet hetzelfde; met het toetsenbord blijft het de knop. */
      els.heroMedia.addEventListener('click', openZoom);
      if (els.charmsOpen) els.charmsOpen.addEventListener('click', openZoom);
      if (els.zoomClose) els.zoomClose.addEventListener('click', function () { els.zoom.close(); });
    }

    /* Stipjes en pijlen horen bij het aantal foto's van dít moment, dus ze
       worden opnieuw gezet zodra de baan verandert. Bij één foto staat er
       niets: een enkel stipje zegt niets en de pijlen zouden allebei uit
       staan.

       De stipjes zijn een aanduiding en geen knoppen. Een raakvlak van 44 om
       een stipje van 6 met 8 ruimte ertussen overlapt zijn buren volledig,
       waarna elke tik bij het laatste stipje uitkomt. Bedienen doe je met de
       veeg, op desktop met de pijlen, en met het toetsenbord via de baan zelf:
       die staat in de markup op tabindex 0 en reageert dan op de pijltoetsen. */
    function syncHeroControls(count, index) {
      heroSlideCount = count;
      heroIndex = Math.max(0, Math.min(count - 1, index || 0));
      var many = count > 1;
      if (els.heroDots) {
        var html = '';
        if (many) {
          for (var i = 0; i < count; i++) {
            html += '<span class="ilbb__hero-dot' + (i === heroIndex ? ' is-on' : '') + '"></span>';
          }
        }
        els.heroDots.innerHTML = html;
        els.heroDots.hidden = !many;
      }
      if (els.heroPrev) els.heroPrev.hidden = !many;
      if (els.heroNext) els.heroNext.hidden = !many;
      if (els.heroMedia) {
        if (many) els.heroMedia.setAttribute('tabindex', '0');
        else els.heroMedia.removeAttribute('tabindex');
      }
      heroSyncIndex(heroIndex, true);
    }

    function heroSyncIndex(i, force) {
      if (i === heroIndex && !force) return;
      heroIndex = i;
      if (els.heroDots) {
        var dots = els.heroDots.children;
        for (var d = 0; d < dots.length; d++) {
          dots[d].className = 'ilbb__hero-dot' + (d === i ? ' is-on' : '');
        }
      }
      if (els.heroPrev) els.heroPrev.disabled = i <= 0;
      if (els.heroNext) els.heroNext.disabled = i >= heroSlideCount - 1;
    }

    function heroScrollTo(i) {
      if (!els.heroMedia || heroSlideCount < 2) return;
      var target = Math.max(0, Math.min(heroSlideCount - 1, i));
      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var w = els.heroMedia.clientWidth || 0;
      if (els.heroMedia.scrollTo) {
        els.heroMedia.scrollTo({ left: target * w, behavior: reduce ? 'auto' : 'smooth' });
      } else {
        els.heroMedia.scrollLeft = target * w;
      }
      heroSyncIndex(target);
    }

    if (els.heroMedia) {
      els.heroMedia.addEventListener('scroll', function () {
        if (heroSlideCount < 2) return;
        var w = els.heroMedia.clientWidth || 1;
        heroSyncIndex(Math.max(0, Math.min(heroSlideCount - 1, Math.round(els.heroMedia.scrollLeft / w))));
      }, { passive: true });
    }
    if (els.heroPrev) els.heroPrev.addEventListener('click', function () { heroScrollTo(heroIndex - 1); });
    if (els.heroNext) els.heroNext.addEventListener('click', function () { heroScrollTo(heroIndex + 1); });

    /* Welke charms er in de gekozen set zitten, voor de lade achter de held en
       de regel 'Charms' op de winkelwagenregel.

       Alleen de tab Onze sets schrijft hier. Ook syncCustom() zette zijn keuze
       eerst in deze context, en omdat collectProperties() bij een gecureerde
       set dezelfde context leest, kwam dan de verkeerde inhoud op de bestelling.
       Zelf samenstellen heeft zijn eigen weergaves (de armband in stap 3 en de
       gekozen links) en zijn eigen bron voor de winkelwagen
       (state.custom.picks). Wie later iets onder de tweede tab wil dat hier op
       lijkt, geeft dat een eigen context in plaats van deze te delen. */
    var packCtx = { charms: [], title: '', upgrade: null };

    function renderChosenCharms(charms, count, title, upgrade) {
      var list = (charms || []).slice(0, count);
      packCtx = { charms: list, title: title || '', upgrade: upgrade || null };
      renderCharmsOpen(list, count);
    }

    function fillSheet() {
      var charms = packCtx.charms;
      if (els.sheetTitle) els.sheetTitle.textContent = fmt(S.sheetTitle, { count: charms.length, set: packCtx.title });
      if (els.sheetSub) {
        var show = S.sheetSub && packCtx.upgrade;
        els.sheetSub.textContent = show ? fmt(S.sheetSub, { size: sizeName(packCtx.upgrade) }) : '';
        els.sheetSub.hidden = !show;
      }
      if (!els.sheetGrid) return;
      els.sheetGrid.innerHTML = '';
      charms.forEach(function (ch) {
        if (!ch) return;
        var item = document.createElement('div');
        item.className = 'ilbb__sheet-item';
        item.innerHTML =
          '<span class="ilbb__sheet-media">' +
            (ch.image ? '<img src="' + esc(ch.image) + '" alt="" loading="lazy">' : '') +
          '</span>' +
          '<span class="ilbb__sheet-name">' + esc(ch.label) + '</span>';
        els.sheetGrid.appendChild(item);
      });
    }

    function biggestSize(vibe) {
      var entries = sizesOf(vibe.variants, curatedMetal(vibe));
      var last = null;
      entries.forEach(function (e) { if (e.variant.available) last = e.letter; });
      return last;
    }

    /* ---------- curated tab ---------- */

    function currentVibe() { return state.vibe != null ? data.vibes[state.vibe] : null; }

    function selectVibe(idx, scroll, initial) {
      state.vibe = idx;
      var vibe = data.vibes[idx];
      els.vibes.forEach(function (b) {
        var on = Number(b.getAttribute('data-ilbb-vibe')) === idx;
        b.classList.toggle('is-selected', on);
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      if (!els.builder) return;
      els.builder.hidden = false;
      els.builder.style.setProperty('--vibe-color', vibe.color);
      /* Het pakketje staat buiten de builder, dus de kleur moet op de sectie. */
      root.style.setProperty('--vibe-color', vibe.color);

      if (els.quote) {
        els.quote.hidden = !vibe.quote;
        els.quote.textContent = vibe.quote ? '“' + vibe.quote + '”' : '';
      }
      renderMetals(els.metals, vibe.variants, state.metal, function (m) { state.metal = m; renderCurated(); });
      if (!state.size) state.size = S.defaultSize;
      renderCurated();
      if (!initial) publish('interlinked_bundle_vibe_selected', { vibe: vibe.title });
      if (scroll) els.builder.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }

    /* Eén materiaal betekent geen materiaalkeuze. Er stond een uitgeschakelde pil
       met "Zilver" als eerste stap van het pad: een genummerde stap die geen tik
       kost en de rest omlaag duwt. */
    function renderMetals(container, variants, active, onPick) {
      if (!container) return;
      var metals = metalsOf(variants);
      if (!S.showMetal || metals.length < 2) {
        container.hidden = true;
        container.innerHTML = '';
        return;
      }
      container.hidden = false;
      container.innerHTML = '';
      metals.forEach(function (m) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'ilbb__metal' + (m === active ? ' is-selected' : '');
        b.setAttribute('aria-pressed', m === active ? 'true' : 'false');
        b.textContent = m;
        b.addEventListener('click', function () { onPick(m); });
        container.appendChild(b);
      });
    }

    function curatedMetal(vibe) {
      return effMetal(vibe.variants, S.showMetal ? state.metal : S.defaultMetal);
    }

    /* De maat die net is aangetikt. Zijn rondjes vallen er één voor één in
       (is-telt in bundle-builder.css). Alleen na een tik op een maat: de
       tegels worden ook opnieuw opgebouwd bij een andere set of bij het
       laden, en dan hoort er niets te tellen. */
    var telMaat = '';

    function renderCurated() {
      var vibe = currentVibe();
      if (!vibe || !els.sizes) return;
      var entries = sizesOf(vibe.variants, curatedMetal(vibe));
      var byLetter = {};
      entries.forEach(function (e) { byLetter[e.letter] = e.variant; });
      state.size = pickSize(state.size || S.defaultSize, entries);

      els.sizes.innerHTML = '';
      var chosenEntry = null;
      entries.forEach(function (entry) {
        var selected = entry.letter === state.size;
        if (selected) chosenEntry = entry;
        var card = buildSizeCard(entry, selected, vibe.color);
        if (selected && entry.letter === telMaat) card.classList.add('is-telt');
        if (entry.variant.available) {
          card.addEventListener('click', function () {
            state.size = entry.letter;
            telMaat = entry.letter;
            renderCurated();
            telMaat = '';
            publish('interlinked_bundle_size_selected', { vibe: vibe.title, size: entry.letter, price: entry.variant.price / 100 });
          });
        }
        els.sizes.appendChild(card);
      });

      var chosen = byLetter[state.size];
      var chosenCount = chosen ? charmCount(chosen.opt1, state.size) : (FALLBACK_COUNTS[state.size] || 0);
      /* Voor "later bijkopen": een Basic van Flower Garden bevat de eerste drie
         charms van de set, dus de andere zeven mag je daar gewoon zien. */
      curatedCount = chosenCount;
      renderHero(vibe, state.size, chosenCount, chosen);
      renderSizeInfo(chosenEntry);
      var biggest = biggestSize(vibe);
      renderChosenCharms(vibe.charms, chosenCount, vibe.title, biggest !== state.size ? biggest : null);
      renderSummary(els.sum, {
        set: vibe.title,
        letter: state.size,
        count: chosenCount,
        metal: curatedMetal(vibe),
        variant: chosen
      });
      renderDoos(els.doos, (vibe.charms || []).slice(0, chosenCount), chosenCount);
      renderNudge(els.nudge, chosen, entries, state.size);
      updateAtc(els.atc, chosen);
      updateSticky();
      syncReco();
    }

    /* Gratis verzending geldt voor de hele bestelling, niet voor deze ene set.
       Rekende de bouwer alleen met de variantprijs, dan zag iemand met €25 in
       de cart bij een Basic van €19,95 "Nog €10,05 tot gratis verzending",
       terwijl de drempel allang gehaald was — en de cart-drawer, die wél met
       cart.total_price rekent, sprak dat een tik later tegen.

       Nul tot de eerste /cart.js binnen is: dat is de stand voor wie met een
       lege cart binnenkomt, en dus de veilige aanname. */
    var cartTotal = 0;

    function freeShipReached(price) {
      return cartTotal + price >= S.freeShipThreshold;
    }

    function refreshCartTotal() {
      fetch(rootUrl() + 'cart.js', { headers: { Accept: 'application/json' } }).then(function (r) {
        return r.ok ? r.json() : null;
      }).then(function (cart) {
        if (!cart || typeof cart.total_price !== 'number') return;
        if (cart.total_price === cartTotal) return;
        cartTotal = cart.total_price;
        // Alleen de twee ingangen: allebei bewaken zelf of hun tab bestaat.
        renderCurated();
        syncCustom();
      }).catch(function () { /* noop: dan blijft de nudge op de variantprijs staan */ });
    }

    /* Wijs alleen naar een grotere maat als die er echt is en als die de drempel
       voor gratis verzending haalt. Zonder die check bleef de nudge vragen om een
       maat die je al gekozen had. */
    function freeShipUpgrade(entries, currentLetter) {
      var best = null;
      (entries || []).forEach(function (e) {
        if (e.letter === currentLetter) return;
        if (!e.variant.available) return;
        if (!freeShipReached(e.variant.price)) return;
        if (!best || e.variant.price < best.variant.price) best = e;
      });
      return best;
    }

    /* Onder deze afstand tot de drempel noemen we het bedrag zelf in plaats van
       een maat groter. Favorite kost 27,95 en de drempel ligt op 30: dat gat van
       €2,05 sluit je met één losse charm van €4,95 uit "Later bijkopen", en dan
       staat er €32,90. Wees hierboven en de code wees naar Complete op 44,95,
       dus €17 extra om €3,95 verzending te besparen — dat is geen aanbod maar
       een drempel, en hij stond aan in precies de stand waarin de pagina opent. */
    var NUDGE_GAP_MAX = 500;

    /* De regel boven de knop noemt sinds de rondgang van 10 oktober 2026 ook
       wat verzending kost: de lade en de koopkaart zeiden alleen wat je
       misloopt, en het bedrag kwam pas na het adres in de checkout in beeld.
       {shipping} is dat bedrag, {amount} wat er nog tot de grens ontbreekt.

       Naar een grotere maat wijzen we alleen als die hooguit één losse charm
       duurder is. Bij 3 charms wees de regel naar 10 (€25 extra); dat is
       hetzelfde lokkertje dat bij 5 charms al weg was. Zonder zo'n aanbod
       staat er alleen het bedrag (shipping_text, "Verzending {amount}."). */
    function renderNudge(el, variant, entries, currentLetter) {
      if (!el) return;
      el.hidden = true;
      if (!variant || freeShipReached(variant.price)) return;
      var gap = S.freeShipThreshold - cartTotal - variant.price;
      var kosten = { shipping: money(S.shippingCost), amount: money(gap) };
      var eenCharm = S.partCharm || NUDGE_GAP_MAX;
      var text = '';
      if (gap <= NUDGE_GAP_MAX && S.freeShipNudge) {
        text = fmt(S.freeShipNudge, kosten);
      } else {
        var upgrade = freeShipUpgrade(entries, currentLetter);
        if (upgrade && S.lNudge && upgrade.variant.price - variant.price <= eenCharm) {
          text = fmt(S.lNudge, { shipping: kosten.shipping, size: sizeName(upgrade.letter) });
        } else if (S.shippingText) {
          text = fmt(S.shippingText, { amount: kosten.shipping });
        }
      }
      if (!text) return;
      el.textContent = text;
      el.hidden = false;
    }

    function updateAtc(btn, variant) {
      if (!btn) return;
      if (!variant || !variant.available) {
        btn.disabled = true;
        btn.textContent = variant ? S.soldOutText : S.atcLabel;
      } else {
        btn.disabled = false;
        /* Zonder prijs: die staat al rechtsboven in de kaart, en twee keer
           hetzelfde bedrag op één kaart is er één te veel (koopkaartronde,
           21 oktober 2026). Zo is het ook de knop van de productpagina. */
        btn.textContent = S.atcLabel;
      }
    }

    /* Samenvattingskaart: wat je gekozen hebt links, het geld rechts. */
    /* Werkt voor allebei de verschijningsvormen: op de tab Samengesteld bestaan
       de titel- en inhoudsregel niet, want die staan in de held en onder de
       maattegels. Alleen invullen wat er is. */
    function renderSummary(sum, info) {
      if (!sum || !sum.price) return;
      var v = info.variant;
      if (sum.title) sum.title.textContent = fmt(S.summaryTitle, { set: info.set, size: sizeName(info.letter) });
      if (sum.contents) {
        sum.contents.textContent = S.summaryContents ? fmt(S.summaryContents, {
          count: info.count,
          metal: String(info.metal || '').toLowerCase()
        }) : '';
        sum.contents.hidden = !S.summaryContents;
      }
      sum.price.textContent = v ? money(v.price) : '';

      /* Waar de losse prijs vandaan komt, als zin en niet als kolom bedragen.

         Hier stond eerst alleen het bedrag ("los gekocht €36,70"): een claim die
         je moest geloven. De opbouw eronder zetten als rijtje armband, charms,
         tool met bedragen erachter loste dat niet op, want een verticale kolom
         bedragen onder een prijs leest als de bon van deze bundel. Een zin die
         met "Los" begint zegt in het eerste woord welke kant het is.

         De besparing zelf staat op de maattegels, waar vergeleken wordt; hier
         staat alleen de losse prijs, één keer. */
      if (sum.opbouw) {
        var loose = v ? looseTotal(v, info.count) : 0;
        var showOpbouw = v && loose > v.price && S.breakdownText;
        sum.opbouw.innerHTML = showOpbouw ? breakdownHtml(S.breakdownText, money(loose), info.count) : '';
        sum.opbouw.hidden = !showOpbouw;
      }
    }

    /* Het bedrag vet, de rest van de zin niet: vet is voorbehouden aan getallen,
       badges en knoppen. De zin komt uit een instelling en gaat dus door esc()
       voordat er een element omheen komt; splitsen op {amount} in plaats van op
       een eigen scheidingsteken, zodat er geen teken bestaat dat de instelling
       kan bevatten en de opmaak kan breken. */
    function breakdownHtml(tpl, amount, count) {
      var parts = String(tpl).split('{amount}');
      var out = '';
      for (var i = 0; i < parts.length; i++) {
        if (i) out += '<b>' + esc(amount) + '</b>';
        out += esc(fmt(parts[i], { count: count }));
      }
      return out;
    }

    /* ---------- custom tab ---------- */

    /* De gekozen charms als vlakke lijst, in de volgorde waarin ze gekozen zijn.
       Gebruikt door de armband-preview en door het pakketje. */
    function charmByLabel(label) {
      var found = null;
      (data.custom && data.custom.pool ? data.custom.pool : []).forEach(function (c) {
        if (c.label === label) found = c;
      });
      return found;
    }

    function customCharmList() {
      var items = [];
      state.custom.picks.forEach(function (label) {
        var ch = charmByLabel(label);
        if (ch && ch.available !== false) items.push(ch);
      });
      return items;
    }

    var customPoolTotal = function () {
      return state.custom.picks.length;
    };

    function customMetal() {
      if (!data.custom) return S.defaultMetal;
      return effMetal(data.custom.variants, S.showMetal ? state.custom.metal : S.defaultMetal);
    }

    function customMax() {
      if (!data.custom || !state.custom.size) return FALLBACK_COUNTS[state.custom.size] || 0;
      var v = variantFor(data.custom.variants, state.custom.size, customMetal());
      return v ? charmCount(v.opt1, state.custom.size) : (FALLBACK_COUNTS[state.custom.size] || 0);
    }

    /* Wat er nog moet, in één formulering die op drie plekken hergebruikt wordt:
       op de dichte stap, in de balk onderaan en op de knop. Eén huis voor de
       teller betekent dat de kaart en de knop het niet hoeven te herhalen. */
    function remainingText(n) {
      if (n === 1) return S.remainingOne || 'nog 1 charm';
      return fmt(S.remaining, { count: n });
    }

    function stepName(n) {
      var labels = S.stepLabels || [];
      return labels[n - 1] || '';
    }

    /* Stap 3 gaat alleen open als je set vol is. Ervoor valt er niets te zien
       behalve lege plekken, en een knop die je nog niet mag indrukken. */
    function canOpen(n) {
      if (n < 3) return true;
      var max = customMax();
      return max > 0 && customPoolTotal() >= max;
    }

    function initCustom() {
      if (!data.custom) return;
      state.custom.size = S.defaultSize;
      renderMetals(els.customMetals, data.custom.variants, state.custom.metal, function (m) {
        state.custom.metal = m; renderCustom();
      });
      if (els.customMetalLabel) els.customMetalLabel.hidden = !els.customMetals || els.customMetals.hidden;
      buildRail();
      bindRows();
      if (els.afTerug) els.afTerug.addEventListener('click', function () { openStep(2, true); });
      if (els.gal && els.galStip) {
        var stippen = els.galStip.children;
        els.gal.addEventListener('scroll', function () {
          var vak = els.gal.firstElementChild;
          if (!vak) return;
          var nu = Math.round(els.gal.scrollLeft / (vak.getBoundingClientRect().width + 8));
          Array.prototype.forEach.call(stippen, function (st, i) { st.classList.toggle('is-nu', i === nu); });
        }, { passive: true });
      }
      renderCharmCats();
      state.custom.step = 1;
      applyStep(false);
      renderCustom();
    }

    /* ---------- pad: rail en stappen ---------- */

    /* De hele dichte rij is de knop, niet alleen het woord "wijzig". Dat woord
       staat er om te laten zien dat de rij iets doet; het is geen los doel van
       12 pixels hoog. */
    function bindRows() {
      Array.prototype.forEach.call(els.wzItems, function (li) {
        var row = li.querySelector('[data-ilbb-row]');
        if (!row) return;
        var n = Number(row.getAttribute('data-ilbb-row'));
        row.addEventListener('click', function () { openStep(n, true); });
      });
    }

    function buildRail() {
      if (!els.railBar) return;
      els.railBar.innerHTML = '';
      for (var i = 1; i <= STEP_COUNT; i++) {
        (function (n) {
          var seg = document.createElement('button');
          seg.type = 'button';
          seg.className = 'ilbb__rail-seg il-raakvlak il-raakvlak--verticaal';
          seg.setAttribute('data-ilbb-seg', n);
          seg.setAttribute('aria-label', stepName(n));
          seg.addEventListener('click', function () {
            if (!canOpen(n)) return;
            openStep(n, true);
          });
          els.railBar.appendChild(seg);
        })(i);
      }
    }

    function renderRail() {
      if (els.railStep) els.railStep.textContent = fmt(S.railText, { step: state.custom.step, max: STEP_COUNT });
      if (els.railName) els.railName.textContent = stepName(state.custom.step);
      if (!els.railBar) return;
      var segs = els.railBar.querySelectorAll('[data-ilbb-seg]');
      Array.prototype.forEach.call(segs, function (seg) {
        var n = Number(seg.getAttribute('data-ilbb-seg'));
        seg.classList.toggle('is-now', n === state.custom.step);
        seg.classList.toggle('is-done', n < state.custom.step);
        seg.disabled = !canOpen(n);
      });
    }

    function stepItem(n) {
      var found = null;
      Array.prototype.forEach.call(els.wzItems, function (li) {
        if (Number(li.getAttribute('data-ilbb-wz')) === n) found = li;
      });
      return found;
    }

    function applyStep(scroll) {
      var wasAf = els.panelCustom && els.panelCustom.classList.contains('is-af');
      if (els.panelCustom) els.panelCustom.classList.toggle('is-af', state.custom.step === 3);
      Array.prototype.forEach.call(els.wzItems, function (li) {
        var n = Number(li.getAttribute('data-ilbb-wz'));
        var open = n === state.custom.step;
        li.classList.toggle('is-open', open);
        var body = li.querySelector('[data-ilbb-body]');
        var row = li.querySelector('[data-ilbb-row]');
        if (body) body.hidden = !open;
        if (row) row.hidden = open;
      });
      renderRail();
      renderRows();
      if (scroll) scrollToStep(state.custom.step);
      if (state.custom.step === 3 && !wasAf) animeerAf();
    }

    /* Als je armband af is klikken je charms er een voor een in, en gaat er
       daarna één keer glans over het staal. Alleen bij binnenkomst van stap 3,
       niet bij elke wissel erin; bij minder beweging staat hij er meteen. */
    function animeerAf() {
      if (!els.finalBand) return;
      if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      var links = els.finalBand.querySelectorAll('button.ilbb-link');
      Array.prototype.forEach.call(links, function (b, i) {
        b.classList.remove('is-klik');
        b.style.animationDelay = (250 + i * 110) + 'ms';
      });
      void els.finalBand.offsetWidth;
      Array.prototype.forEach.call(links, function (b) { b.classList.add('is-klik'); });
      if (els.galArm) {
        els.galArm.classList.remove('is-glans');
        els.galArm.style.setProperty('--ilbb-glans-na', (250 + links.length * 110 + 150) + 'ms');
        void els.galArm.offsetWidth;
        els.galArm.classList.add('is-glans');
      }
    }

    function openStep(n, scroll) {
      if (!canOpen(n)) return;
      if (state.custom.step === n) { if (scroll) scrollToStep(n); return; }
      state.custom.step = n;
      applyStep(scroll);
      publish('interlinked_custom_step_opened', { step: n, name: stepName(n) });
    }

    function scrollToStep(n) {
      var li = stepItem(n);
      if (!li || !li.scrollIntoView) return;
      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      li.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
    }

    /* De dichte stap draagt je keuze, niet alleen zijn naam. Anders kost
       dichtklappen je het zicht op wat je gekozen had. */
    function renderRows() {
      if (!data.custom) return;
      var max = customMax();
      var total = customPoolTotal();
      var v = variantFor(data.custom.variants, state.custom.size, customMetal());
      var sizeSub = '';
      if (v) {
        sizeSub = money(v.price);
        var looseRow = looseTotal(v, max);
        if (looseRow > v.price && S.wasText) {
          sizeSub += ', ' + fmt(S.wasText, { amount: money(looseRow) });
        }
      }

      fillRow(1, {
        title: fmt(S.rowSizeTitle, { size: sizeName(state.custom.size), count: max }),
        sub: sizeSub,
        act: S.changeLabel
      });

      /* De dichte charmstap toont je plekken als een stukje armband: lege links
         en de charms die er al in zitten. Dat zegt hoeveel plekken er zijn en
         hoeveel er vol zijn, dus er hoeft geen zin meer bij. In stap 3 niet,
         want daar ligt je hele armband er direct onder. */
      var linksInRow = state.custom.step !== 3 && max > 0;
      fillRow(2, {
        title: total > 0 ? fmt(S.rowCharmsTitle, { count: total }) : stepName(2),
        sub: linksInRow || total >= max ? '' : (total > 0 ? remainingText(max - total) : fmt(S.rowCharmsTodo, { max: max })),
        chips: linksInRow,
        act: total > 0 ? S.changeLabel : S.openLabel
      });

      fillRow(3, {
        title: stepName(3),
        sub: canOpen(3) ? S.rowDoneSub : remainingText(max - total),
        act: canOpen(3) ? S.openLabel : '',
        dim: !canOpen(3)
      });
    }

    function fillRow(n, info) {
      var li = stepItem(n);
      if (!li) return;
      var row = li.querySelector('[data-ilbb-row]');
      if (!row) return;
      var t = row.querySelector('[data-ilbb-row-t]');
      var s = row.querySelector('[data-ilbb-row-s]');
      var chips = row.querySelector('[data-ilbb-row-chips]');
      var a = row.querySelector('[data-ilbb-row-a]');

      if (t) t.textContent = info.title || '';
      if (s) {
        s.textContent = info.sub || '';
        s.hidden = !info.sub;
      }
      if (chips) {
        chips.hidden = !info.chips;
        if (info.chips) {
          chips.innerHTML = '';
          var gekozen = customCharmList();
          for (var k = 0; k < customMax(); k++) {
            chips.appendChild(armLink(gekozen[k], 'i'));
            brugRuimte(chips, gekozen[k], 'i');
          }
          hangRuimte(chips, gekozen);
        }
      }
      if (a) {
        a.textContent = info.act || '';
        a.hidden = !info.act;
      }
      row.classList.toggle('is-dim', !!info.dim);
      row.disabled = !!info.dim;
    }

    /* ---------- custom tab: render ---------- */

    function renderCustom() {
      if (!data.custom || !els.customSizes) return;
      var entries = sizesOf(data.custom.variants, customMetal());
      state.custom.size = pickSize(state.custom.size || S.defaultSize, entries);

      els.customSizes.innerHTML = '';
      entries.forEach(function (entry) {
        var card = buildSizeCard(entry, entry.letter === state.custom.size, null);
        if (entry.letter === state.custom.size && entry.letter === telMaat) card.classList.add('is-telt');
        if (entry.variant.available) {
          card.addEventListener('click', function () {
            state.custom.size = entry.letter;
            trimSelection();
            telMaat = entry.letter;
            renderCustom();
            telMaat = '';
            publish('interlinked_custom_size_selected', { size: entry.letter });
            /* Na een maat hoort de volgende vraag, tenzij je set daarmee al vol is. */
            openStep(2, true);
          });
        }
        els.customSizes.appendChild(card);
      });

      renderCharmCats();
      syncCustom();
    }

    /* Alles wat aan de charmkeuze hangt, op één plek. */
    function syncCustom() {
      if (!data.custom) return;
      var max = customMax();
      var entries = sizesOf(data.custom.variants, customMetal());
      var v = variantFor(data.custom.variants, state.custom.size, customMetal());

      renderCharmGrid();
      renderPicked();
      renderFinal();
      renderSummary(els.customSum, {
        set: data.custom.title,
        letter: state.custom.size,
        count: max,
        metal: customMetal(),
        variant: v
      });
      renderNudge(els.customNudge, v, entries, state.custom.size);
      updateCustomAtc(v);

      /* Geen sprong naar het eindscherm zodra je set vol is. Vol is niet
         hetzelfde als tevreden: de meeste mensen wisselen er daarna nog een.
         De balk onderaan biedt de volgende stap aan, jij kiest wanneer. */
      renderRail();
      renderRows();
      updateSticky();
      syncReco();
      /* Elke wijziging aan de set gaat hier langs, dus dit is de enige plek waar
         bewaren hoeft te staan. Wegschrijven is goedkoop en de set is klein. */
      bewaarSet();
      syncDeel();
    }

    /* Kleinere maat: de laatst gekozen charms vallen eraf, want die zijn het
       minst overdacht en het is de enige keuze die zichzelf uitlegt. */
    function trimSelection() {
      var max = customMax();
      if (state.custom.picks.length > max) state.custom.picks = state.custom.picks.slice(0, max);
    }

    /* De gekozen charms in de kop van stap 2: tegelijk je voortgang en de manier
       om er een af te halen. Lege plekken blijven staan, zodat het aantal dat je
       nog mag kiezen zichtbaar is zonder dat er een tekst bij hoeft.

       De regel "tik om weg te halen" die hier onder de plekken hing is eruit:
       de rij past sinds de kop op dieet ging op één regel, en een tweede regel
       eronder haalde de helft van die winst weer weg. Wat hij zei staat nog in
       het aria-label van elke gevulde plek. */
    function renderPicked() {
      var el = els.picked;
      if (!el) return;
      var max = customMax();
      var items = customCharmList();
      el.innerHTML = '';
      var extra = 0;
      for (var i = 0; i < max; i++) {
        var ch = items[i];
        el.appendChild(ch ? pickedChip(ch, i) : armLink(null, 'span', 'ilbb__pick'));
        extra += brugRuimte(el, ch, 'span', 'ilbb__pick');
      }
      el.style.setProperty('--ilbb-n', String(max + extra));
      hangRuimte(el, items);
    }

    /* Ruimte onder een korte rij links voor de hangers die erin zitten. Zonder
       die ruimte bleef van een hanger alleen een lege link met een half ringetje
       over, en zag je niet welke charm je gekozen had. */
    function hangRuimte(el, items) {
      var onder = 0;
      items.forEach(function (ch) {
        if (!ch || !ch.handle || !S.hangers || !S.hangers[ch.handle]) return;
        onder = Math.max(onder, hangerOnder(ch.handle));
      });
      el.style.setProperty('--ilbb-hang', onder.toFixed(3));
    }

    /* Het tweede uiteinde van het bruggetje ligt drie links verder, ook in de
       korte rijen. Daar werd het rond zijn eerste link en ster afgeknipt, en
       dan zag je niet dat je het bruggetje had gekozen. Net als in stap 3
       komen er kale links tussen, zodat het de charm erna niet bedekt. Geeft
       terug hoeveel plekken erbij kwamen. */
    function brugRuimte(el, ch, tag, extraClass) {
      if (!isBrug(ch)) return 0;
      for (var k = 0; k < BRUG_AFSTAND; k++) {
        var kaal = armLink(null, tag, extraClass);
        kaal.setAttribute('aria-hidden', 'true');
        el.appendChild(kaal);
      }
      return BRUG_AFSTAND;
    }

    function pickedChip(ch, index) {
      var b = armLink(ch, 'button', 'ilbb__pick ilbb__pick--on');
      b.type = 'button';
      b.setAttribute('aria-label', fmt(S.removeAria, { name: ch.label }));
      b.addEventListener('click', function () { removeAt(index); });
      return b;
    }

    /* Eén link van de armband, zoals op de homepage (interlinked-zo-werkt):
       een lege link, een charm die erin geklikt zit, of een hanger die aan zijn
       plek bungelt. De uitsnede van de foto's staat in de CSS bij .ilbb-link;
       hier alleen welke foto erin hoort. Een charm die net gekozen is krijgt
       is-klik, dan klikt hij met een korte beweging op zijn plek. */
    var laatstGekozen = null;

    /* Waar de link zit in elke uitgesneden hangerfoto (assets/il-uitsnede-*.png),
       in pixels van die foto: W de breedte van de foto, l de linkerkant van de
       link, b de breedte van de link, t de bovenkant en o de onderkant van de
       hanger. Gemeten op 25 september
       2026 op het alfakanaal, want elke foto is anders gekaderd: met één maat
       voor alle zes schoven de links over hun buren of lieten ze een gat.

       Het sterrenbruggetje heeft twee links met een ketting ertussen; l2 is de
       linkerkant van de tweede. Die ligt drie links verder, en daar rekent de
       schaal op, zodat allebei de uiteinden op een plek van de armband vallen.

       Nieuwe hanger: meet hem op dezelfde manier en zet hem erbij. Zonder maat
       valt hij terug op die van de paarse bloem. */
    var HANGER_MAAT = {
      'paarse-bloem': { W: 217, l: 56, b: 109, t: 7, o: 208 },
      'zilveren-ster': { W: 252, l: 100, b: 110, t: 9, o: 242 },
      'blauw-steentje': { W: 245, l: 61, b: 132, t: 9, o: 235 },
      'roze-steentje': { W: 245, l: 61, b: 132, t: 9, o: 235 },
      'vliegtuig-met-steentjes': { W: 236, l: 77, b: 86, t: 8, o: 226 },
      'camera-met-hartje': { W: 267, l: 83, b: 107, t: 9, o: 256 },
      'sterrenbruggetje': { W: 263, l: 21, b: 60, t: 11, o: 250, l2: 192 }
    };
    var BRUG_AFSTAND = 3;

    function hangerMaat(handle) {
      return HANGER_MAAT[handle] || HANGER_MAAT['paarse-bloem'];
    }

    /* De foto zo groot en zo verschoven dat zijn link precies de plek vult. De
       marges in procenten rekenen vanaf de breedte van de plek, ook de
       bovenmarge, en dus klopt het op elke maat van de link. */
    function perPlek(m) {
      return m.l2 ? (m.l2 - m.l) / BRUG_AFSTAND : m.b;
    }

    /* Hoe ver een hanger onder de rij uitsteekt, in linkbreedtes. Een link is
       1,136 keer zo breed als hoog, dus de rij zelf is 1 / 1,136 linkbreedte. */
    function hangerOnder(handle) {
      var m = hangerMaat(handle);
      return Math.max(0, (m.o - m.t) / perPlek(m) - 1 / 1.136);
    }

    function hangerImg(url, handle) {
      var m = hangerMaat(handle);
      var pp = perPlek(m);
      /* Eager: een hanger verschijnt pas als je hem kiest, en lazy liet Chrome
         de foto van het bruggetje in de kop van stap 2 nooit laden. */
      return '<img src="' + esc(url) + '" alt="" decoding="async" style="width:' +
        (m.W / pp * 100).toFixed(2) + '%;margin-left:' + (-m.l / pp * 100).toFixed(2) +
        '%;margin-top:' + (-m.t / pp * 100).toFixed(2) + '%">';
    }

    function isBrug(ch) {
      return !!(ch && ch.handle && S.hangers && S.hangers[ch.handle] && hangerMaat(ch.handle).l2);
    }

    function armLink(ch, tag, extraClass) {
      var el = document.createElement(tag);
      var hanger = ch && ch.handle && S.hangers ? S.hangers[ch.handle] : null;
      el.className = 'ilbb-link' + (ch ? (hanger ? ' ilbb-link--hanger' : ' ilbb-link--charm') : ' ilbb-link--leeg') +
        (ch && ch.label === laatstGekozen ? ' is-klik' : '') + (extraClass ? ' ' + extraClass : '');
      if (!ch) {
        if (S.legeLink) el.style.backgroundImage = 'url("' + S.legeLink + '")';
      } else if (hanger) {
        el.innerHTML = hangerImg(hanger, ch.handle);
      } else if (ch.image) {
        el.style.backgroundImage = 'url("' + ch.image + '")';
      }
      return el;
    }

    /* Aan en uit op dezelfde tegel. Nog een tik op een charm die je al hebt is
       geen tweede exemplaar maar een vergissing die je terugneemt. */
    function toggleCharm(ch) {
      /* Tweede slot op dezelfde deur: de tegel is al geen knop meer, maar een
         keuze kan ook uit een herstelde staat komen. */
      if (!ch || ch.available === false) return;
      var at = state.custom.picks.indexOf(ch.label);
      if (at !== -1) { removeAt(at); return; }
      if (customPoolTotal() >= customMax()) { shakePicked(); return; }
      state.custom.picks.push(ch.label);
      laatstGekozen = ch.label;
      syncCustom();
      laatstGekozen = null;
      publish('interlinked_custom_charm_added', { charm: ch.label, total: customPoolTotal(), max: customMax() });
    }

    function removeAt(index) {
      if (index < 0 || index >= state.custom.picks.length) return;
      var label = state.custom.picks[index];
      state.custom.picks.splice(index, 1);
      syncCustom();
      publish('interlinked_custom_charm_removed', { charm: label, total: customPoolTotal() });
    }

    /* De rij met je plekken schudt als je er een charm te veel bij wilt: daar
       staat het antwoord, want alle links zijn vol. */
    function shakePicked() {
      var el = els.picked;
      if (!el) return;
      el.classList.remove('is-shake');
      void el.offsetWidth;
      el.classList.add('is-shake');
    }

    /* ---------- charm-categorieën ---------- */

    function catMatches(cat, ch) {
      return cat.handles.indexOf(String(ch.handle || '').trim().toLowerCase()) !== -1;
    }

    function activeCat() {
      var found = null;
      CATS.forEach(function (c) { if (c.label === state.custom.category) found = c; });
      return found;
    }

    function renderCharmCats() {
      if (!els.charmCats) return;
      if (!data.custom || !CATS.length) { els.charmCats.hidden = true; return; }
      var pool = data.custom.pool || [];
      var visible = [];
      CATS.forEach(function (c) {
        var hit = false;
        pool.forEach(function (ch) { if (catMatches(c, ch)) hit = true; });
        if (hit) visible.push(c);
      });
      if (!visible.length) { els.charmCats.hidden = true; return; }
      els.charmCats.hidden = false;
      els.charmCats.innerHTML = '';
      var mk = function (label, catKey) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'ilbb__charm-cat il-raakvlak il-raakvlak--verticaal' + (state.custom.category === catKey ? ' is-selected' : '');
        b.setAttribute('aria-pressed', state.custom.category === catKey ? 'true' : 'false');
        b.textContent = label;
        b.addEventListener('click', function () {
          state.custom.category = catKey;
          renderCharmCats();
          renderCharmGrid();
          publish('interlinked_custom_category_selected', { category: catKey });
        });
        els.charmCats.appendChild(b);
      };
      mk(S.catAllLabel || 'Alles', 'all');
      visible.forEach(function (c) { mk(c.label, c.label); });
    }

    /* Tikken is aanzetten, nog een tik zet hem uit. De stepper op elke tegel is
       eruit: drie knoppen om een charm van 38 pixels heen betekende twee tegels
       naast elkaar en twintig rijen. */
    /* In dit raster is alles een charm, dus het woord staat er niet achter:
       "Zilveren sterrenhemel" in plaats van "Zilveren sterrenhemel charm". Dat
       scheelt op een tegel van 110 pixels het verschil tussen een naam die past
       en een die wordt afgekapt. De lade, de winkelwagen en de knoppen in de
       armband houden de volle naam. */
    function kortNaam(label) {
      return String(label || '').replace(/\s+charm$/i, '');
    }

    function renderCharmGrid() {
      if (!els.charmGrid) return;
      var max = customMax();
      var full = max > 0 && customPoolTotal() >= max;
      var cat = activeCat();
      els.charmGrid.innerHTML = '';
      els.charmGrid.classList.toggle('is-full', full);
      (data.custom.pool || []).forEach(function (ch) {
        if (cat && !catMatches(cat, ch)) return;
        var on = state.custom.picks.indexOf(ch.label) !== -1;
        /* Een charm die op is blijft staan met foto en naam, maar wordt een div
           in plaats van een button: dezelfde keuze als bij de maattegels, zodat
           hij niet in de tabvolgorde belandt en niet aan te tikken is. */
        var out = ch.available === false;
        var item = document.createElement(out ? 'div' : 'button');
        if (!out) item.type = 'button';
        item.className = 'ilbb__charm' + (on && !out ? ' is-active' : '') + (out ? ' is-soldout' : '');
        if (out) {
          item.setAttribute('aria-disabled', 'true');
        } else {
          item.setAttribute('aria-pressed', on ? 'true' : 'false');
          if (full && !on) item.setAttribute('aria-disabled', 'true');
        }
        item.innerHTML =
          '<span class="ilbb__charm-img"></span>' +
          '<span class="ilbb__charm-name">' + esc(kortNaam(ch.label)) + '</span>' +
          (out ? '<span class="ilbb__charm-out">' + esc(S.soldOutText) + '</span>' : '') +
          (on && !out ? '<span class="ilbb__charm-tick il-vinkje" aria-hidden="true"></span>' : '');
        if (ch.image) {
          item.querySelector('.ilbb__charm-img').style.backgroundImage = 'url("' + ch.image + '")';
        }
        if (!out) item.addEventListener('click', function () { toggleCharm(ch); });
        els.charmGrid.appendChild(item);
      });
    }

    /* Het eindbeeld: je armband, van rand tot rand. Je charms in het midden,
       met aan beide kanten kale links die buiten het scherm doorlopen, zodat je
       ziet dat het een armband is en geen rijtje losse charms. Op een telefoon
       past de rij niet en dat is de bedoeling: het product loopt over de rand.

       Elke charm is een knop. Hier zie je pas of het klopt, dus hier hoort ook
       de weg terug: tikken haalt de charm weg en zet je in de lijst, op de plek
       waar je een andere kiest. De kale links zijn beeld en geen knop. */
    var KALE_LINKS = 4;
    function renderFinal() {
      if (!els.finalBand) return;
      var items = customCharmList();
      var max = customMax();
      els.finalBand.innerHTML = '';
      var kaal = function () { var k = armLink(null, 'span'); k.setAttribute('aria-hidden', 'true'); return k; };
      var k;
      /* Zoveel ruimte onder de armband als de langste hanger nodig heeft, zodat
         er niets van wordt afgeknipt. */
      var onder = 0;
      var extra = 0;
      items.forEach(function (ch) {
        if (ch && ch.handle && S.hangers && S.hangers[ch.handle]) onder = Math.max(onder, hangerOnder(ch.handle));
        if (isBrug(ch)) extra += BRUG_AFSTAND;
      });
      els.finalBand.style.setProperty('--ilbb-hang', onder.toFixed(3));
      /* Zoveel plekken beslaan je charms. De CSS maakt de links zo smal dat die
         plekken allemaal op het scherm passen: bij tien charms, of met een
         bruggetje erin, viel de eerste anders links van het scherm af. */
      els.finalBand.style.setProperty('--ilbb-n', String(max + extra));
      for (k = 0; k < KALE_LINKS; k++) els.finalBand.appendChild(kaal());
      for (var i = 0; i < max; i++) {
        els.finalBand.appendChild(finalLink(items[i], i));
        /* Het tweede uiteinde van het bruggetje ligt drie links verder. De
           plekken daartussen en eronder zijn kale links, zodat de armband
           doorloopt en de charm erna niet onder het bruggetje verdwijnt. */
        if (isBrug(items[i])) for (k = 0; k < BRUG_AFSTAND; k++) els.finalBand.appendChild(kaal());
      }
      for (k = 0; k < KALE_LINKS; k++) els.finalBand.appendChild(kaal());
      renderDoos(els.customDoos, items, max);
    }

    /* De eerste regel van "In je doosje": de charms, met de foto van de eerste
       en alle namen eronder. Bij Samengesteld de charms van de gekozen set en
       maat, bij Zelf samenstellen die je zelf gekozen hebt. De andere regels
       staan vast in snippets/ilbb-doos.liquid. */
    function renderDoos(doos, items, count) {
      var charms = (items || []).filter(Boolean);
      if (doos.titel) doos.titel.textContent = fmt(S.doosCharmsTitle, { count: count });
      if (doos.namen) doos.namen.textContent = charms.map(function (ch) {
        return (ch.label || '').replace(/\s+charm$/i, '');
      }).join(', ');
      if (doos.foto) {
        doos.foto.innerHTML = '';
        var eerste = charms[0];
        if (eerste && eerste.image) {
          var img = document.createElement('img');
          img.src = eerste.image;
          img.alt = '';
          img.loading = 'lazy';
          doos.foto.appendChild(img);
        }
      }
    }

    function finalLink(ch, index) {
      if (!ch) return armLink(null, 'span');
      var b = armLink(ch, 'button');
      b.type = 'button';
      b.title = ch.label || '';
      b.setAttribute('aria-label', fmt(S.removeAria, { name: ch.label }));
      b.addEventListener('click', function () {
        removeAt(index);
        openStep(2, true);
      });
      return b;
    }

    function updateCustomAtc(variant) {
      if (!els.customAtc) return;
      var max = customMax();
      var total = customPoolTotal();
      if (!variant || !variant.available) {
        els.customAtc.disabled = true;
        els.customAtc.textContent = variant ? S.soldOutText : S.atcLabel;
      } else if (total < max) {
        els.customAtc.disabled = true;
        els.customAtc.textContent = fmt(S.atcTodo, { rest: remainingText(max - total) });
      } else {
        els.customAtc.disabled = false;
        els.customAtc.textContent = S.atcLabel;
      }
    }

    /* ---------- sticky bar ---------- */

    function activeSelection() {
      if (state.tab === 'curated') {
        var vibe = currentVibe();
        if (!vibe || !state.size) return null;
        var v = variantFor(vibe.variants, state.size, curatedMetal(vibe));
        if (!v || !v.available) return null;
        return { title: vibe.title + ' · ' + sizeName(state.size), naam: vibe.title, variant: v, ready: true };
      }
      if (data.custom && state.custom.size) {
        var cv = variantFor(data.custom.variants, state.custom.size, customMetal());
        if (!cv || !cv.available) return null;
        return { title: data.custom.title + ' · ' + sizeName(state.custom.size), naam: data.custom.title, variant: cv, ready: customPoolTotal() >= customMax() };
      }
      return null;
    }

    /* De balk komt op zodra de koopknop van de open tab niet in beeld is. Op de
       tab Zelf samenstellen zit die knop in stap 3, dus tot je set vol is staat
       hij er altijd: hij draagt daar wat er nog moet, in plaats van een
       uitgeschakelde knop zonder reden. */
    function activeAtcInView() {
      var btn = state.tab === 'curated' ? els.atc : els.customAtc;
      if (!btn || !btn.offsetParent) return false;
      var r = btn.getBoundingClientRect();
      return r.bottom > 0 && r.top < (window.innerHeight || 0);
    }

    /* Onderaan de pagina zou deze balk over de footer heen blijven hangen: de
       eigen koopknop waar hij normaal voor wijkt is dan allang uit beeld, dus
       activeAtcInView() alleen is niet genoeg. Verberg 'm daarom ook zodra de
       footer zelf in beeld komt. */
    var footerEl = (function () {
      var names = ['.shopify-section-group-footer-group', 'footer.footer', '#footer', 'footer'];
      for (var i = 0; i < names.length; i++) {
        var el = document.querySelector(names[i]);
        if (el) return el;
      }
      return null;
    })();
    function footerInView() {
      if (!footerEl) return false;
      var r = footerEl.getBoundingClientRect();
      return r.top < (window.innerHeight || 0);
    }

    /* De balk hoort te wachten tot de formaattegels voorbij zijn. Op 390px
       eindigen die op y=687 en begint de koopknop pas op y=897: in dat stuk
       ertussen stond de balk er al, met een prijs en een koopknop, terwijl de
       keuze waar hij over gaat nog gewoon op het scherm staat. Twee koopknoppen
       in beeld, waarvan de bovenste de echte is.

       "Voorbij" is scherper dan "niet in beeld": staan de tegels nog ónder de
       viewport, dan ben je er nog niet langs en hoort de balk er ook niet te
       zijn. Vandaar de onderkant tegen de bovenrand (bottom <= 0) en niet de
       treffertest die activeAtcInView() doet.

       Een tegelblok zonder offsetParent telt als voorbij. Dat is stap 1 van
       Zelf samenstellen zodra hij dichtgeklapt is: de maat staat dan vast, je
       bent in de charmlijst, en daar draagt de balk wat er nog moet. */
    function activeSizesEl() {
      return state.tab === 'curated' ? els.sizes : els.customSizes;
    }
    function sizesPassed() {
      var el = activeSizesEl();
      if (!el || !el.offsetParent) return true;
      return el.getBoundingClientRect().bottom <= 0;
    }

    /* De balk heeft drie standen, en zegt in alle drie wat het volgende is:
       nog niet vol (wat er mist), vol maar nog in de lijst (volgende), en in het
       eindscherm (kopen). Zo hoeft er geen aparte knop onder de veertig tegels. */
    var stickyMode = 'atc';
    var stickyAtcLabel = els.stickyAtc ? els.stickyAtc.textContent : '';

    function updateSticky() {
      if (!els.sticky || !S.stickyEnabled) return;
      var sel = activeSelection();
      if (!sel) { els.sticky.classList.remove('is-visible'); return; }
      /* Zolang je in de lijst staat gaat deze knop naar het eindscherm, of hij nu
         aan mag of niet. Hij zei eerst "Voeg toe aan winkelwagen" in het grijs:
         dat belooft de verkeerde handeling, en bij de vijfde charm veranderden
         het woord en de kleur tegelijk. Nu verandert alleen de kleur. */
      var toStep3 = state.tab === 'custom' && state.custom.step !== 3;
      stickyMode = toStep3 ? 'next' : 'atc';

      /* Alleen de setnaam, zonder "· 5 charms". Het aantal staat al op de
         actieve tegel en in de prijsregel ernaast, en samen waren ze 60px te
         breed voor de balk: "Flower Garden · 5 charms" werd "Flower Garden…",
         de enige afgekapte tekst van de winkel (V10). De succeskaart houdt de
         volledige titel wél, want daar is de regel niet krap. */
      els.stickyTitle.textContent = sel.naam || sel.title;
      els.stickyPrice.textContent = money(sel.variant.price);
      if (els.stickyNote) {
        var todo = state.tab === 'custom' && !sel.ready ? customMax() - customPoolTotal() : 0;
        els.stickyNote.textContent = todo > 0 ? remainingText(todo) : '';
        els.stickyNote.hidden = todo <= 0;
      }
      els.stickyAtc.textContent = toStep3 ? (S.nextLabel || stickyAtcLabel) : stickyAtcLabel;
      els.stickyAtc.disabled = !sel.ready;
      els.sticky.hidden = false;
      els.sticky.classList.toggle('is-visible', sizesPassed() && !activeAtcInView() && !footerInView());
    }

    if (els.sticky && S.stickyEnabled && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(function () { updateSticky(); }, { threshold: 0.1 });
      [els.atc, els.customAtc].forEach(function (b) { if (b) io.observe(b); });
      /* Drempel 0 voor de tegels en de footer, want hier gaat het om het moment
         van langs de rand gaan. Met 0.1 komt de laatste melding binnen terwijl
         er nog een tiende van het tegelblok staat; sizesPassed() zegt dan nog
         "nee" en er volgt daarna geen melding meer, dus de balk zou de rest van
         de pagina weg blijven. */
      var edgeIo = new IntersectionObserver(function () { updateSticky(); }, { threshold: 0 });
      [els.sizes, els.customSizes, footerEl].forEach(function (el) { if (el) edgeIo.observe(el); });
    }

    /* ---------- add to cart ---------- */

    function collectProperties() {
      var props = {};
      if (state.tab !== 'curated' && state.custom.picks.length) {
        /* In de volgorde waarin ze gekozen zijn, zodat de picklijst dezelfde rij
           leest als de armband in stap 3. */
        props['Charms'] = state.custom.picks.join(', ');
        /* Dezelfde keuze nog een keer, als variant-ID's en met een underscore
           ervoor zodat de klant hem nergens ziet. Hier hangt de voorraad aan:
           een gecureerde set boekt af via zijn componentlijst, maar een eigen
           set heeft per bestelling een andere inhoud. De functie set-uitklappen
           leest deze regel en zet hem om in de armband, de charm tool en de
           gekozen charms, zodat Shopify de voorraad per charm al in de
           winkelwagen bewaakt in plaats van pas bij het binnenkomen van de
           bestelling.

           Hiervoor stond hier _charmhandles, dat een Shopify Flow-regel las.
           Die is vervallen: Flow boekte pas af als de bestelling binnen was,
           dus twee mensen konden tegelijk de laatste charm bestellen, en een
           annulering boekte niets terug. Het weghalen van die eigenschap is
           meteen de schakelaar, want de voorwaarde van die regel is dat hij
           er staat.

           Variant-ID's en niet de titels uit 'Charms': titels worden
           gecorrigeerd zodra een foto iets anders blijkt te tonen, en dan zou
           het afboeken stil op de verkeerde charm uitkomen.

           Een charm zonder vid komt uit de metaobject-terugval en wijst naar
           geen product. Dan blijft de eigenschap weg, klapt de regel niet uit,
           en gaat de set als een enkele regel de deur uit. Dat valt bij het
           inpakken op; een halve lijst zou dat niet doen. */
        var gekozen = customCharmList();
        var vids = gekozen.map(function (ch) {
          return ch && ch.vid ? String(ch.vid) : '';
        }).filter(Boolean);
        if (vids.length === gekozen.length && vids.length) {
          props['_charmvariants'] = vids.map(function (id) {
            return 'gid://shopify/ProductVariant/' + id;
          }).join(',');
        }
      }
      /* Een gecureerde set legde niet vast wat erin zat: de regel kwam zonder
         properties binnen en voor het inpakken moest je terug naar de handmatige
         sortering van de charm-collectie. Wijzigt die sortering ooit, dan is van een
         oude bestelling niet meer na te gaan wat de klant gekregen heeft.
         packCtx.charms is hier de juiste bron en niet vibe.charms: die is in
         renderChosenCharms() al gesneden op het gekozen aantal, dus een Basic van
         Flower Garden levert de eerste drie labels en niet alle tien. */
      if (state.tab === 'curated' && packCtx.charms && packCtx.charms.length) {
        props['Charms'] = packCtx.charms.map(function (ch) {
          return ch && ch.label ? ch.label : '';
        }).filter(Boolean).join(', ');
      }
      return props;
    }

    // Blokkeert een tweede addToCart() zolang de eerste nog loopt: de knop zelf
    // wordt nooit disabled (alleen een CSS-klasse), en drie knoppen wijzen naar
    // dezelfde functie (atc, customAtc, stickyAtc), dus een dubbele tap kon
    // anders twee keer /cart/add.js afvuren.
    var addToCartBusy = false;

    function addToCart(btn) {
      var sel = activeSelection();
      if (!sel || !sel.ready) return;
      if (addToCartBusy) return;
      addToCartBusy = true;
      // Zodra de hoofdregel binnen is mag de catch hieronder niet meer naar
      // /cart/add navigeren: dat zou de set een tweede keer toevoegen. Een fout
      // ná dit punt (tool, cart-event, succes-modal) is geen reden om opnieuw
      // toe te voegen.
      var lineAdded = false;
      var body = { items: [{ id: sel.variant.id, quantity: 1, properties: collectProperties() }] };
      btn.classList.add('is-loading');
      fetch(rootUrl() + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify(body)
      }).then(function (r) {
        if (!r.ok) throw new Error('cart');
        return r.json();
      }).then(function () {
        lineAdded = true;
        /* Wat erin zit, vóór vergeetGekocht() de keuze van Zelf samenstellen wist. */
        var beelden = (state.tab === 'custom' ? customCharmList() : packCtx.charms || []).map(function (ch) {
          return ch && ch.image;
        });
        if (state.tab === 'custom') vergeetGekocht();
        btn.classList.remove('is-loading');
        /* Het getekende vinkje en niet het teken uit het lettertype: dat
           verandert van vorm zodra er een andere letter gekozen wordt. */
        var prev = btn.innerHTML;
        btn.innerHTML = '<span class="il-vinkje ilbb__atc-vinkje" aria-hidden="true"></span>' + esc(S.addedLabel);
        setTimeout(function () { btn.innerHTML = prev; }, 2500);
        publish('interlinked_bundle_added_to_cart', {
          title: sel.title, variantId: sel.variant.id, price: sel.variant.price / 100, tab: state.tab
        });
        // Hier stond een tweede cart/add.js voor de charm tool. Die zit nu
        // fysiek in elke set-doos in plaats van als €0-regel in de cart: het
        // PDP-koopflow voegde hem nooit toe, een verwijderde set liet de tool
        // achter (en dan rekende de Buy X Get Y-korting hem alsnog af), en de
        // klant kon het aantal vrij ophogen. Wat de klant er nog van ziet is
        // de tegel in "In je pakketje" en de regel onder de set in de cart.
        addToCartBusy = false;
        // Badge + drawer syncen via Horizon's echte cart-event; action 'update'
        // houdt de drawer dicht zodat de eigen succes-modal primair blijft.
        // __ilCartPending is de terugval als interlinked-cart-events.js
        // (fetchpriority="low") nog niet geladen is wanneer dit vuurt.
        window.__ilCartPending = { action: 'update', id: sel.variant.id, quantity: 1 };
        document.dispatchEvent(new CustomEvent('il:cart:changed', {
          detail: window.__ilCartPending
        }));
        /* De charms vliegen eerst naar het tasje; de bevestiging legt een scherm over de
           header en zou de landing anders afdekken. Zonder beweging is dat meteen. */
        (U.vlieg ? U.vlieg(btn, beelden) : Promise.resolve()).then(function () {
          openSuccess(sel);
        });
      }).catch(function () {
        addToCartBusy = false;
        btn.classList.remove('is-loading');
        if (lineAdded) return;
        // Cart-permalink ondersteunt properties[Key]=value; zonder deze meesturen
        // verliest een custom set zijn Charms-lijst.
        var params = 'id=' + sel.variant.id + '&quantity=1';
        var props = body.items[0].properties || {};
        Object.keys(props).forEach(function (k) {
          params += '&properties[' + encodeURIComponent(k) + ']=' + encodeURIComponent(props[k]);
        });
        if (state.tab === 'custom') vergeetGekocht();
        window.location.href = rootUrl() + 'cart/add?' + params;
      });
    }

    // Ververst de cart-drawer server-side en opent hem. Valt terug op de
    // /cart-pagina als de drawer (nog) niet beschikbaar is.
    function openCartDrawer(fallbackHref) {
      var drawer = document.querySelector('#cart-drawer');
      if (!drawer || typeof drawer.open !== 'function') {
        if (fallbackHref) window.location.href = fallbackHref;
        return;
      }
      fetch(rootUrl() + '?sections=cart-drawer-section').then(function (r) {
        return r.json();
      }).then(function (sections) {
        var html = sections['cart-drawer-section'];
        if (!html) return;
        var tmp = document.createElement('div');
        tmp.innerHTML = html;
        var fresh = tmp.querySelector('.cart-drawer__inner');
        var cur = document.querySelector('#cart-drawer .cart-drawer__inner');
        if (fresh && cur) cur.replaceWith(fresh);
      }).catch(function () {}).then(function () {
        if (typeof drawer.open === 'function') drawer.open();
      });
    }

    var successOpener = null;

    function closeSuccess() {
      if (!els.success) return;
      els.success.hidden = true;
      if (successOpener && typeof successOpener.focus === 'function') successOpener.focus();
    }

    /* Dezelfde keuze als het stapeltje in de drawer (cart-products.liquid):
       vooraan de eerste charm die geen hanger is, de hangers erachter. */
    function vulStapel(charms) {
      var el = els.successStapel;
      if (!el) return;
      var voor = null, achter = [];
      (charms || []).forEach(function (ch) {
        if (!ch || !ch.image || (voor && achter.length >= 2)) return;
        var hanger = S.hangers && ch.handle && S.hangers[ch.handle];
        if (!voor && !hanger) voor = ch;
        else if (achter.length < 2) achter.push(ch);
      });
      if (!voor) voor = achter.shift();
      if (!voor) { el.hidden = true; el.innerHTML = ''; return; }
      var kaart = function (ch, n) {
        return '<img class="il-stapel__k il-stapel__k--' + n + '" src="' + esc(ch.image) + '" alt="">';
      };
      el.innerHTML = (achter[1] ? kaart(achter[1], 3) : '') + (achter[0] ? kaart(achter[0], 2) : '') + kaart(voor, 1);
      el.hidden = false;
    }

    function openSuccess(sel) {
      if (!els.success) return;
      successOpener = document.activeElement;
      els.successTitle.textContent = fmt(S.successTitle, { title: sel.title });
      if (els.successNaam) els.successNaam.textContent = sel.title;
      if (els.successPrijs) els.successPrijs.textContent = money(sel.variant.price);
      vulStapel(state.tab === 'curated' ? packCtx.charms : customCharmList());
      if (els.suggest && state.tab === 'curated' && data.vibes.length > 1 && S.suggestText) {
        var nextIdx = (state.vibe + 1) % data.vibes.length;
        var next = data.vibes[nextIdx];
        els.suggest.hidden = false;
        els.suggest.innerHTML = '';
        var b = document.createElement('button');
        b.type = 'button';
        b.innerHTML = esc(fmt(S.suggestText, { title: next.title })) + ' <span aria-hidden="true">→</span>';
        b.addEventListener('click', function () {
          els.success.hidden = true;
          selectVibe(nextIdx, true);
        });
        els.suggest.appendChild(b);
      } else if (els.suggest) {
        els.suggest.hidden = true;
      }
      els.success.hidden = false;
      if (els.successClose) els.successClose.focus();
    }

    /* ---------- later bijkopen ---------- */

    /* De rij onder de bouwer bood aan wat je net gekozen had. Hij wordt
       server-side gerenderd uit dezelfde collectie als de charmkiezer, in
       dezelfde volgorde, dus de eerste twaalf "later bijkopen" waren letterlijk
       de eerste twaalf waaruit je zojuist gekozen hebt — en bij een gecureerde
       set stond de Zilveren ster erbij die al in de set zat.

       Hier gaat eruit wat de klant al heeft. De sectie rendert tien kaartjes
       reserve, zodat de rij aanschuift in plaats van korter te worden. */
    var recoBox = root.querySelector('[data-ilbb-reco]');
    var recoVisible = recoBox ? (Number(recoBox.getAttribute('data-ilbb-reco')) || 12) : 12;
    var curatedCount = 0;

    /* Op handle en niet op naam: de categorieën verderop matchen om dezelfde
       reden op handle. Komt de charmpool uit het metaobject in plaats van uit
       een collectie, dan is er geen handle en filtert dit niets weg — de rij
       blijft dan staan zoals hij was, en dat is de veilige uitkomst. */
    function ownedHandles() {
      var out = {};
      var list = [];
      if (state.tab === 'curated') {
        var vibe = currentVibe();
        if (vibe) list = (vibe.charms || []).slice(0, curatedCount);
      } else {
        list = customCharmList();
      }
      list.forEach(function (ch) {
        var h = ch && ch.handle ? String(ch.handle).trim().toLowerCase() : '';
        if (h) out[h] = true;
      });
      return out;
    }

    /* Verbergen en niet weghalen: laat je een charm weer los, dan hoort hij
       terug te komen zonder dat de rij opnieuw opgehaald wordt. */
    function syncReco() {
      if (!recoBox) return;
      var owned = ownedHandles();
      var items = recoBox.querySelectorAll('[data-il-charm-handle]');
      var shown = 0;
      var changed = false;
      for (var i = 0; i < items.length; i++) {
        var h = String(items[i].getAttribute('data-il-charm-handle') || '').trim().toLowerCase();
        var hide = owned[h] === true || shown >= recoVisible;
        if (items[i].hidden !== hide) changed = true;
        items[i].hidden = hide;
        if (!hide) shown++;
      }

      /* De carrousel meet zelf of de pijlen en de randfades aan moeten; door
         kaartjes te verbergen verandert scrollWidth, en dat is geen scroll-,
         resize- of laadmoment. il-charm-slider.js hangt aan het scroll-event van
         de rij, dus dat is hier het goedkoopste zetje. */
      if (changed) {
        var row = recoBox.querySelector('.il-cs__row');
        if (row) row.dispatchEvent(new Event('scroll', { bubbles: true }));
      }
    }

    /* ---------- events ---------- */

    els.tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        selectTab(tab.getAttribute('data-ilbb-tab'), true);
      });
    });

    /* Deelbare tab: ?tab=custom opent Zelf samenstellen, ?tab=curated of geen
       parameter opent Samengesteld. De Nederlandse labels werken ook, want die
       staan in de URL die mensen uit de adresbalk kopiëren. */
    var TAB_ALIAS = {
      custom: 'custom',
      'zelf-samenstellen': 'custom',
      zelf: 'custom',
      curated: 'curated',
      samengesteld: 'curated'
    };

    function tabFromUrl() {
      var raw = '';
      try {
        raw = new URL(window.location.href).searchParams.get('tab') || '';
        if (!raw) raw = (window.location.hash || '').replace('#', '');
      } catch (e) { return null; }
      return TAB_ALIAS[raw.trim().toLowerCase()] || null;
    }

    function writeTabParam(name) {
      if (!window.history || !window.history.replaceState) return;
      try {
        var url = new URL(window.location.href);
        if (name === 'curated') url.searchParams.delete('tab');
        else url.searchParams.set('tab', name);
        window.history.replaceState({}, '', url.toString());
      } catch (e) { /* noop */ }
    }

    function selectTab(name, updateUrl) {
      var target = null;
      els.tabs.forEach(function (t) { if (t.getAttribute('data-ilbb-tab') === name) target = t; });
      if (!target) return false;
      state.tab = name;
      els.tabs.forEach(function (t) {
        var on = t === target;
        t.classList.toggle('is-active', on);
        t.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      els.panels.forEach(function (p) {
        p.hidden = p.getAttribute('data-ilbb-panel') !== name;
        p.classList.toggle('is-active', !p.hidden);
      });
      if (name === 'custom' && data.custom && els.customSizes && !els.customSizes.childElementCount) initCustom();
      publish('interlinked_bundle_tab_viewed', { tab: name });
      updateSticky();
      /* De rij staat onder beide tabs, dus wisselen van tab wisselt ook wat de
         klant al heeft. Deze functie rendert niets opnieuw, dus het is goedkoop. */
      syncReco();
      if (updateUrl) writeTabParam(name);
      return true;
    }

    els.vibes.forEach(function (btn) {
      btn.addEventListener('click', function () {
        selectVibe(Number(btn.getAttribute('data-ilbb-vibe')), false);
      });
    });

    if (els.sheet && (els.charmsOpen || els.doosOpen)) {
      /* Twee knoppen openen de lade: de held en de charmregel in "In je
         doosje". De focus gaat terug naar de knop waarmee je hem opende. */
      var sheetOpener = null;
      var closeSheet = function () {
        els.sheet.hidden = true;
        if (sheetOpener) sheetOpener.focus();
      };
      var openSheet = function (opener, bron) {
        if (!packCtx.charms.length) return;
        sheetOpener = opener;
        fillSheet();
        els.sheet.hidden = false;
        if (els.sheetClose) els.sheetClose.focus();
        publish('interlinked_charms_opened', { set: packCtx.title, tab: state.tab, bron: bron });
      };
      if (els.doosOpen) els.doosOpen.addEventListener('click', function () { openSheet(els.doosOpen, 'doosje'); });
      if (els.sheetClose) els.sheetClose.addEventListener('click', closeSheet);
      els.sheet.addEventListener('click', function (e) { if (e.target === els.sheet) closeSheet(); });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && !els.sheet.hidden) closeSheet();
      });
    }

    if (els.atc) els.atc.addEventListener('click', function () { addToCart(els.atc); });
    if (els.customAtc) els.customAtc.addEventListener('click', function () { addToCart(els.customAtc); });
    if (els.stickyAtc) els.stickyAtc.addEventListener('click', function () {
      if (stickyMode === 'next') { openStep(3, true); return; }
      addToCart(state.tab === 'curated' && els.atc ? els.atc : (els.customAtc || els.stickyAtc));
    });

    if (els.successClose) els.successClose.addEventListener('click', closeSuccess);
    if (els.continueBtn) els.continueBtn.addEventListener('click', closeSuccess);
    if (els.toCart) els.toCart.addEventListener('click', function (e) {
      var drawer = document.querySelector('#cart-drawer');
      if (!drawer || typeof drawer.open !== 'function') return; // laat de link naar /cart navigeren
      e.preventDefault();
      els.success.hidden = true;
      openCartDrawer(els.toCart.getAttribute('href'));
    });
    if (els.success) els.success.addEventListener('click', function (e) { if (e.target === els.success) closeSuccess(); });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && els.success && !els.success.hidden) closeSuccess();
    });

    /* Hier stonden twee blokken die op 7 augustus 2026 zijn weggehaald.

       Het eerste legde een cross-sell-product in de winkelwagen vanuit het
       succesvenster. Het tweede opende een modal met TikToks eigen
       embed-widget, en trok daarvoor een script van tiktok.com binnen op de
       kooppagina. Waarom ze weg zijn staat bij de markup in
       sections/bundle-builder.liquid; het bewijs zelf staat nu als eigen
       sectie onder de bouwer. */

    /* Er staat altijd een set aan. Zonder startkeuze is de pagina bij binnenkomst
       leeg: geen maat, geen prijs, geen knop, alleen tegels. Met ?set=<handle>
       kan een TikTok-link rechtstreeks naar één set wijzen. */
    function vibeFromUrl() {
      var want = '';
      try {
        want = new URL(window.location.href).searchParams.get('set') || '';
      } catch (e) { return -1; }
      want = want.trim().toLowerCase();
      if (!want) return -1;
      for (var i = 0; i < data.vibes.length; i++) {
        var v = data.vibes[i];
        var handle = String(v.url || '').split('?')[0].split('/').pop().toLowerCase();
        if (handle === want || String(v.title || '').toLowerCase() === want) return i;
      }
      return -1;
    }

    /* Zet een rij charm-handles klaar in de bouwer. Twee bronnen komen hier
       uit: ?charms= in de URL (vanaf de losse-charms-pagina of een gedeelde
       link) en de set die de vorige keer in de browser bleef staan.

       springen zegt of dit ook de tab mag verzetten. Bij een link is dat de
       bedoeling, want de bezoeker klikte er zelf op. Bij een teruggezette set
       alleen als de URL geen tab of set noemt (zie herstelBewaard). De stap
       gaat altijd mee, zodat je bij het openen van de tab op je armband uitkomt
       en niet op de maatkeuze die je al gemaakt had. */
    function pasCharmsToe(wanted, maat, springen) {
      if (!data.custom || !wanted || !wanted.length) return false;

      var pool = data.custom.pool || [];
      var labels = [];
      wanted.forEach(function (h) {
        var handle = String(h || '').trim().toLowerCase();
        if (!handle) return;
        pool.forEach(function (ch) {
          /* Een charm die intussen op is slaan we over, anders zet de link een
             keuze terug die de kiezer zelf niet meer aanbiedt: de teller telt
             hem dan wel en de armband niet. */
          if (ch.available === false) return;
          if (String(ch.handle || '').toLowerCase() === handle && labels.indexOf(ch.label) === -1) {
            labels.push(ch.label);
          }
        });
      });
      if (!labels.length) return false;

      /* Eerst de tab opbouwen, dan pas vullen: renderCustom vult customSizes,
         en daarna slaat selectTab zijn eigen initCustom over omdat die rij niet
         meer leeg is. De rail en de stappen zouden dan nooit gebouwd worden. */
      if (els.customSizes && !els.customSizes.childElementCount) initCustom();
      if (springen) selectTab('custom', false);

      var metal = effMetal(data.custom.variants, S.defaultMetal);
      var best = null;

      /* Een meegegeven maat wint, zolang de set er nog in past. Zo blijft een
         gedeelde link van 5 charms in een armband van 10 ook een armband van
         10, in plaats van te krimpen naar de kleinste die past. */
      /* Een uitverkochte maat slaan we over: renderCustom zou daarna zelf een
         andere kiezen, en dan staan er meer charms klaar dan erin passen. */
      if (maat) {
        var gevraagd = variantFor(data.custom.variants, maat, metal);
        if (gevraagd && gevraagd.available && charmCount(gevraagd.opt1, maat) >= labels.length) best = maat;
      }
      if (!best) {
        ['B', 'F', 'C'].forEach(function (letter) {
          if (best) return;
          var v = variantFor(data.custom.variants, letter, metal);
          if (v && !v.available) return;
          var cap = v ? charmCount(v.opt1, letter) : (FALLBACK_COUNTS[letter] || 0);
          if (cap >= labels.length) best = letter;
        });
      }
      if (best) state.custom.size = best;

      state.custom.picks = labels.slice(0, customMax());
      renderCustom();
      openStep(state.custom.picks.length >= customMax() ? 3 : 2, false);
      return true;
    }

    /* Vanaf de losse-charms-pagina en vanuit een gedeelde link komt
       ?charms=<handles> mee, eventueel met ?maat=. Die keuze staat hier meteen
       klaar, want "maak er een set van" mag geen tweede rondje kiezen worden. */
    function applyCharmsFromUrl() {
      if (!data.custom) return false;

      var raw = '';
      var maat = '';
      try {
        var params = new URL(window.location.href).searchParams;
        raw = params.get('charms') || '';
        maat = (params.get('maat') || '').trim().toUpperCase();
      } catch (e) { return false; }
      if (!raw) return false;

      var wanted = raw.split(',').map(function (s) { return s.trim().toLowerCase(); }).filter(Boolean);
      if (!pasCharmsToe(wanted, maat, true)) return false;

      publish('interlinked_custom_prefilled', { charms: state.custom.picks.length, size: state.custom.size });
      return true;
    }

    /* --- Bewaren en delen ---------------------------------------------------

       De set bestond alleen in dit ene tabblad. Er stond geen localStorage in
       dit bestand en de URL schreef alleen tab weg, dus wie wegklikte begon
       opnieuw en wie hem aan iemand wilde laten zien kon alleen een screenshot
       sturen. De leesroute lag er al; dit is de andere helft.

       Bewaren staat of valt met de regel die het uitlegt: zonder die tekst
       gebeurt er niets, want een set die stilletjes terugkomt is een verrassing
       en geen dienst.

       Een bewaarde armband blijft 30 dagen staan, gerekend vanaf de laatste
       keer dat je hem veranderde. Daarna begint de bouwer weer leeg: een keuze
       van twee maanden terug is geen "vorige keer" meer. */
    var BEWAAR_SLEUTEL = 'il-bb-set';
    var BEWAAR_MS = 30 * 24 * 60 * 60 * 1000;

    /* Tijdens de start schrijft bewaarSet niets weg. Bij ?tab=zelf bouwde
       selectTab de tab eerst op met een lege armband, en syncCustom wiste de
       sleutel dan nog voordat herstelBewaard hem kon lezen. Daarom kwam je
       armband via die link nooit terug. */
    var bewaarKlaar = false;

    /* De set die net in de winkelwagen ging. Die hoeft niet meer te blijven
       staan, want de winkelwagen onthoudt hem al; pas je daarna iets aan, dan
       is het een nieuwe armband en wordt die weer bewaard. */
    var gekocht = '';

    function bewaarAan() {
      return !!(S.bewaar && S.bewaar.tekst);
    }

    function setSleutel(maat, charms) {
      return (maat || '') + ':' + (charms || []).join(',');
    }

    function leesRuw() {
      try {
        if (!window.localStorage) return null;
        var ruw = window.localStorage.getItem(BEWAAR_SLEUTEL);
        return ruw ? JSON.parse(ruw) : null;
      } catch (e) { return null; }
    }

    function handlesVanPicks() {
      if (!data.custom) return [];
      var pool = data.custom.pool || [];
      var uit = [];
      state.custom.picks.forEach(function (label) {
        for (var i = 0; i < pool.length; i++) {
          if (pool[i].label === label && pool[i].handle) { uit.push(pool[i].handle); return; }
        }
      });
      return uit;
    }

    function bewaarSet() {
      if (!bewaarAan() || !bewaarKlaar) return;
      try {
        if (!window.localStorage) return;
        var charms = handlesVanPicks();
        var sleutel = setSleutel(state.custom.size, charms);
        if (!charms.length || sleutel === gekocht) {
          window.localStorage.removeItem(BEWAAR_SLEUTEL);
          return;
        }
        /* Dezelfde armband opnieuw wegschrijven houdt zijn oude datum, zodat
           alleen een echte wijziging de 30 dagen opnieuw laat lopen. */
        var oud = leesRuw();
        var t = oud && oud.t && setSleutel(oud.maat, oud.charms) === sleutel ? oud.t : Date.now();
        window.localStorage.setItem(BEWAAR_SLEUTEL, JSON.stringify({
          v: 2,
          maat: state.custom.size,
          charms: charms,
          t: t
        }));
      } catch (e) {
        /* Privémodus, vol quotum of een browser die opslag blokkeert. Dan
           bewaren we niets en werkt de bouwer verder gewoon. */
      }
    }

    /* Een bewaarde armband uit v1 heeft geen datum. Die bestaat pas sinds 29
       augustus 2026 en is dus jonger dan 30 dagen; hij krijgt er een bij de
       eerste wijziging. */
    function leesBewaard() {
      if (!bewaarAan()) return null;
      var obj = leesRuw();
      if (!obj || !obj.charms || !obj.charms.length) return null;
      if (obj.t && Date.now() - obj.t > BEWAAR_MS) {
        wisBewaard();
        return null;
      }
      return obj;
    }

    function wisBewaard() {
      try { if (window.localStorage) window.localStorage.removeItem(BEWAAR_SLEUTEL); } catch (e) { /* zie boven */ }
    }

    /* De tab blijft staan waar hij is (zie de start). De stap zet hij wel: een
       volle armband opent op stap 3, anders stap 2 met je charms erin en een
       lege plek voor wat er intussen op is. */
    function herstelBewaard(obj) {
      if (!obj) return false;
      if (!pasCharmsToe(obj.charms, obj.maat, false)) return false;
      if (els.terug) els.terug.hidden = false;
      publish('interlinked_custom_hersteld', { charms: state.custom.picks.length, step: state.custom.step });
      return true;
    }

    function vergeetGekocht() {
      gekocht = setSleutel(state.custom.size, handlesVanPicks());
      wisBewaard();
      if (els.terug) els.terug.hidden = true;
    }

    function deelUrl() {
      var handles = handlesVanPicks();
      if (!handles.length) return '';
      try {
        var url = new URL(window.location.href);
        url.hash = '';
        url.searchParams.delete('set');
        /* De utm-tags van de advertentie waarmee de deler binnenkwam gaan niet
           mee naar wie de link krijgt: anders telt dat bezoek ook als klik op
           die advertentie (lens 3, rondgang 10 oktober 2026). De klik-ID's van
           TikTok, Meta en Google doen hetzelfde, dus die ook. Eerst kopiëren,
           want delete() tijdens het doorlopen slaat sleutels over. */
        Array.from(url.searchParams.keys()).forEach(function (k) {
          if (/^(utm_|ttclid$|fbclid$|gclid$)/i.test(k)) url.searchParams.delete(k);
        });
        url.searchParams.set('tab', 'custom');
        url.searchParams.set('charms', handles.join(','));
        url.searchParams.set('maat', state.custom.size);
        return url.toString();
      } catch (e) { return ''; }
    }

    /* De knop verschijnt alleen als er iets te delen is én de browser een
       klembord heeft. Zonder klembord is er geen zinnig alternatief: een veld
       met een link erin dat je zelf moet selecteren is op een telefoon meer
       werk dan het waard is. */
    function syncDeel() {
      if (!els.deel) return;
      var kan = !!(navigator.clipboard && navigator.clipboard.writeText) && !!(S.deel && S.deel.label);
      els.deel.hidden = !kan || !state.custom.picks.length;
    }

    function bindDelen() {
      if (els.deel) {
        els.deel.addEventListener('click', function () {
          var url = deelUrl();
          if (!url) return;
          navigator.clipboard.writeText(url).then(function () {
            els.deel.classList.add('is-klaar');
            if (els.deelTekst) els.deelTekst.textContent = S.deel.klaar;
            publish('interlinked_set_gedeeld', { charms: state.custom.picks.length, size: state.custom.size });
            window.setTimeout(function () {
              els.deel.classList.remove('is-klaar');
              if (els.deelTekst) els.deelTekst.textContent = S.deel.label;
            }, 2500);
          }).catch(function () { /* geweigerd of geen toestemming; knop blijft staan */ });
        });
      }

      if (els.terugWis) {
        els.terugWis.addEventListener('click', function () {
          wisBewaard();
          state.custom.picks = [];
          state.custom.size = S.defaultSize;
          if (els.terug) els.terug.hidden = true;
          renderCustom();
          openStep(1, true);
        });
      }
    }

    /* De kop van de charmstap plakt. Staat de themeheader ook vast, dan moet hij
       daaronder blijven hangen, dus meten we waar de header ophoudt in plaats
       van te gokken. Dat is de hoogte (height) van de header, gecorrigeerd voor
       zijn eigen CSS top-waarde: Horizon zet de sticky header zelf op
       bijvoorbeeld "top: -1px" tegen flikkeren bij het vastklikken, waardoor
       hij eenmaal vastgeklikt 1px boven de viewport begint. Rect.bottom leek
       een alternatief, maar is instabiel: vlak na het laden staat de header nog
       gewoon in de paginaflow, onder de announcementbar, en dan telt bottom die
       announcementbar-hoogte per ongeluk mee (dat gaf juist een grote kier).
       De CSS top-waarde zelf staat vast in de stylesheet en is dus veilig uit
       te lezen via getComputedStyle, ongeacht scroll of paginaflow. */
    var stickyHeaderEl = null;
    function stickyOffset(el) {
      var height = el.getBoundingClientRect().height;
      var cssTop = parseFloat(window.getComputedStyle(el).top);
      if (isNaN(cssTop) || cssTop > 0) cssTop = 0;
      return Math.max(0, Math.round(height + cssTop));
    }
    function syncStickyTop() {
      var names = ['#header-component', '.header-section', 'header.header', '.shopify-section-group-header-group'];
      var top = 0;
      stickyHeaderEl = null;
      for (var i = 0; i < names.length; i++) {
        var el = document.querySelector(names[i]);
        if (!el) continue;
        var pos = window.getComputedStyle(el).position;
        if (pos === 'sticky' || pos === 'fixed') {
          top = stickyOffset(el);
          stickyHeaderEl = el;
          break;
        }
      }
      root.style.setProperty('--ilbb-top', top + 'px');
    }
    syncStickyTop();

    /* Eén meting per frame in plaats van één per event. syncStickyTop doet per
       aanroep vier querySelector-aanroepen plus getComputedStyle en
       getBoundingClientRect, en die laatste twee dwingen de browser de layout
       eerst af te maken. Op mobiel vuurt resize bij elke beweging van de
       adresbalk tijdens het scrollen, dus ongethrotteld was dat precies tijdens
       het scrollen het duurst. De eerste meting hierboven blijft synchroon,
       zodat stickyHeaderEl gezet is voordat de observer hieronder hem oppakt. */
    var stickyTopQueued = false;
    window.addEventListener('resize', function () {
      if (stickyTopQueued) return;
      stickyTopQueued = true;
      requestAnimationFrame(function () {
        stickyTopQueued = false;
        syncStickyTop();
      });
    });

    /* De header krimpt zelf bij het scrollen (de announcementbar valt weg,
       het menu klapt in), en dat gebeurt ná deze eenmalige meting. Zonder
       observer bleef --ilbb-top op de hoogte van de volle header staan,
       waardoor er een reepje charms zichtbaar bleef tussen de ingekrompen
       header en de vastgeplakte kop van deze stap. */
    if (window.ResizeObserver && stickyHeaderEl) {
      var stickyHeaderObserver = new ResizeObserver(function () {
        if (stickyHeaderEl) {
          root.style.setProperty('--ilbb-top', stickyOffset(stickyHeaderEl) + 'px');
        }
      });
      stickyHeaderObserver.observe(stickyHeaderEl);
    }

    if (data.vibes.length) {
      var startVibe = vibeFromUrl();
      selectVibe(startVibe >= 0 ? startVibe : 0, false, true);
    }

    /* Lezen vóór de eerste render van Zelf samenstellen; bewaarSet staat tot
       het eind van de start uit (zie bewaarKlaar). */
    var bewaard = leesBewaard();

    var urlTab = tabFromUrl();
    if (urlTab) selectTab(urlTab, false);
    bindDelen();
    /* Een link wint van wat er bewaard staat: die is van nu en met opzet
       aangeklikt, de bewaarde set is van de vorige keer. De bewaarde armband
       verzet nooit de tab: wie op "Onze sets" klikt (gewoon /pages/sets) wil
       de sets zien en niet zijn armband van vorige keer (Bram, 26 september
       2026). Hij staat klaar achter Zelf samenstellen, en "Maak je eigen set"
       (?tab=custom) opent er direct op. */
    var uitLink = applyCharmsFromUrl();
    if (!uitLink) herstelBewaard(bewaard);
    bewaarKlaar = true;
    if (uitLink) bewaarSet();
    syncDeel();

    /* Ná de eerste render, zodat de pagina niet op een netwerkaanroep wacht:
       met een lege cart verandert er niets, en met een gevulde cart komt de
       badge een tel later goed te staan. Hetzelfde event dat de drawer bijwerkt
       houdt hem daarna gelijk. */
    refreshCartTotal();
    document.addEventListener('il:cart:changed', refreshCartTotal);

    publish('interlinked_bundle_builder_viewed', { vibes: data.vibes.length });
  }

  function boot() {
    document.querySelectorAll('[data-ilbb]').forEach(init);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', function (e) {
    var el = e.target && e.target.querySelector ? e.target.querySelector('[data-ilbb]') : null;
    if (el) init(el);
  });
})();
